const States = [
  {
    "id": "1",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Berat",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "2",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Dibre",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "3",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Durres",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "4",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Elbasan",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "5",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Fier",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "6",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Gjirokaster",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "7",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Gramsh",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "8",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Kolonje",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "9",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Korce",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "10",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Kruje",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "11",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Kukes",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "12",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Lezhe",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "13",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Librazhd",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "14",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Lushnje",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "15",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Mat",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "16",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Mirdite",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "17",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Permet",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "18",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Pogradec"
  },
  {
    "id": "19",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Puke",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "20",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Sarande",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "21",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Shkoder",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "22",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Skrapar",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "23",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Tepelene",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "24",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Tirane",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "25",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Tropoje",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "26",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AF",
    "name": "Vlore",
    "timeZone": "Asia/Kabul"
  },
  {
    "id": "27",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Berat",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "28",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Dibre",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "29",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Durres",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "30",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Elbasan",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "31",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Fier",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "32",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Gjirokaster",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "33",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Gramsh",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "34",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Kolonje",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "35",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Korce",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "36",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Kruje",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "37",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Kukes",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "38",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Lezhe",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "39",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Librazhd",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "40",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Lushnje",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "41",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Mat",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "42",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Mirdite",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "43",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Permet",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "44",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Pogradec",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "45",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Puke",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "46",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Sarande",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "47",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Shkoder",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "48",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Skrapar",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "49",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Tepelene",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "50",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Tirane",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "51",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Tropoje",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "52",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AL",
    "name": "Vlore",
    "timeZone": "Europe/Tirane"
  },
  {
    "id": "53",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Adrar",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "54",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Ain Defla",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "55",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Ain Temouchent",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "56",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Alger",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "57",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Annaba",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "58",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Batna",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "59",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Bechar",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "60",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Bejaia",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "61",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Biskra",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "62",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Blida",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "63",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Bordj Bou Arreridj",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "64",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Bouira",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "65",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Boumerdes",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "66",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Chlef",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "67",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Constantine",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "68",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Djelfa",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "69",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "El Bayadh",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "70",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "El Oued",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "71",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "El Tarf",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "72",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Ghardaia",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "73",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Guelma",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "74",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Illizi",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "75",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Jijel",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "76",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Khenchela",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "77",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Laghouat",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "78",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Mascara",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "79",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Medea",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "80",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Mila",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "81",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Mostaganem",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "82",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "M'sila",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "83",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Naama",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "84",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Oran",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "85",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Ouargla",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "86",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Oum el Bouaghi",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "87",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Relizane",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "88",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Saida",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "89",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Setif",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "90",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Sidi Bel Abbes",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "91",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Skikda",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "92",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Souk Ahras",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "93",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Tamanghasset",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "94",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Tebessa",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "95",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Tiaret",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "96",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Tindouf",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "97",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Tipaza",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "98",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Tissemsilt",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "99",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Tizi Ouzou",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "100",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DZ",
    "name": "Tlemcen",
    "timeZone": "Africa/Algiers"
  },
  {
    "id": "101",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AS",
    "name": "American Somoa",
    "timeZone": "Pacific/Pago_Pago"
  },
  {
    "id": "102",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AD",
    "name": "Andorra",
    "timeZone": "Europe/Andorra"
  },
  {
    "id": "103",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AD",
    "name": "Canillo",
    "timeZone": "Europe/Andorra"
  },
  {
    "id": "104",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AD",
    "name": "Encamp",
    "timeZone": "Europe/Andorra"
  },
  {
    "id": "105",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AD",
    "name": "La Massana",
    "timeZone": "Europe/Andorra"
  },
  {
    "id": "106",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AD",
    "name": "Ordino",
    "timeZone": "Europe/Andorra"
  },
  {
    "id": "107",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AD",
    "name": "Sant Julia de Lori",
    "timeZone": "Europe/Andorra"
  },
  {
    "id": "108",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Bengo",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "109",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Benguela",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "110",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Bie",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "111",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Cabinda",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "112",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Cuando Cubango",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "113",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Cuanza Norte",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "114",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Cuanza Sul",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "115",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Cunene",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "116",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Huambo",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "117",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Huila",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "118",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Luanda",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "119",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Lunda Norte",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "120",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Lunda Sul",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "121",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Malanje",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "122",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Moxico",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "123",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Namibe",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "124",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Uige",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "125",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AO",
    "name": "Zaire",
    "timeZone": "Africa/Luanda"
  },
  {
    "id": "126",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AI",
    "name": "Anguilla",
    "timeZone": "America/Anguilla"
  },
  {
    "id": "127",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AQ",
    "name": "Antarctica",
    "timeZone": "Antarctica/McMurdo"
  },
  {
    "id": "128",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AG",
    "name": "Barbuda",
    "timeZone": "America/Antigua"
  },
  {
    "id": "129",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AG",
    "name": "Saint George",
    "timeZone": "America/Antigua"
  },
  {
    "id": "130",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AG",
    "name": "Saint John",
    "timeZone": "America/Antigua"
  },
  {
    "id": "131",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AG",
    "name": "Saint Mary",
    "timeZone": "America/Antigua"
  },
  {
    "id": "132",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AG",
    "name": "Saint Paul",
    "timeZone": "America/Antigua"
  },
  {
    "id": "133",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AG",
    "name": "Saint Peter",
    "timeZone": "America/Antigua"
  },
  {
    "id": "134",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AG",
    "name": "Saint Philip",
    "timeZone": "America/Antigua"
  },
  {
    "id": "135",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Buenos Aires",
    "timeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "136",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Catamarca",
    "timeZone": "America/Argentina/Catamarca"
  },
  {
    "id": "137",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Chaco",
    "timeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "138",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Chubut",
    "timeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "139",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Cordoba",
    "timeZone": "America/Argentina/Cordoba"
  },
  {
    "id": "140",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Corrientes",
    "timeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "141",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Distrito Federal",
    "timeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "142",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Entre Rios",
    "timeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "143",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Formosa",
    "timeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "144",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Jujuy",
    "timeZone": "America/Argentina/Jujuy"
  },
  {
    "id": "145",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "La Pampa",
    "timeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "146",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "La Rioja",
    "timeZone": "America/Argentina/La_Rioja"
  },
  {
    "id": "147",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Mendoza",
    "timeZone": "America/Argentina/Mendoza"
  },
  {
    "id": "148",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Misiones",
    "timeZone": "America/Argentina/Misiones"
  },
  {
    "id": "149",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Neuquen",
    "timeZone": "America/Argentina/Neuquen"
  },
  {
    "id": "150",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Rio Negro",
    "timeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "151",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Salta",
    "timeZone": "America/Argentina/Salta"
  },
  {
    "id": "152",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "San Juan",
    "timeZone": "America/Argentina/San_Juan"
  },
  {
    "id": "153",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "San Luis",
    "timeZone": "America/Argentina/San_Luis"
  },
  {
    "id": "154",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Santa Cruz",
    "timeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "155",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Santa Fe",
    "timeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "156",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Santiago del Ester",
    "timeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "157",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Tierra del Fuego",
    "timeZone": "America/Argentina/Buenos_Aires"
  },
  {
    "id": "158",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AR",
    "name": "Tucuman",
    "timeZone": "America/Argentina/Tucuman"
  },
  {
    "id": "159",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AM",
    "name": "Armenia",
    "timeZone": "Asia/Yerevan"
  },
  {
    "id": "160",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AW",
    "name": "Aruba",
    "timeZone": "America/Aruba"
  },
  {
    "id": "161",
    "stateCode": "ACT",
    "capitalCityName": "Canberra",
    "countryCode": "AU",
    "name": "Australian Capital",
    "timeZone": "Australia/Canberra"
  },
  {
    "id": "162",
    "stateCode": "NSW",
    "capitalCityName": "Sydney",
    "countryCode": "AU",
    "name": "New South Wales",
    "timeZone": "Australia/Sydney"
  },
  {
    "id": "163",
    "stateCode": "NT",
    "capitalCityName": "Darwin",
    "countryCode": "AU",
    "name": "Northern Territory",
    "timeZone": "Australia/Darwin"
  },
  {
    "id": "164",
    "stateCode": "QLD",
    "capitalCityName": "Brisbane",
    "countryCode": "AU",
    "name": "Queensland",
    "timeZone": "Australia/Brisbane"
  },
  {
    "id": "165",
    "stateCode": "SA",
    "capitalCityName": "Adelaide",
    "countryCode": "AU",
    "name": "South Australia",
    "timeZone": "Australia/Adelaide"
  },
  {
    "id": "166",
    "stateCode": "TAS",
    "capitalCityName": "Hobart",
    "countryCode": "AU",
    "name": "Tasmania",
    "timeZone": "Australia/Hobart"
  },
  {
    "id": "167",
    "stateCode": "WA",
    "capitalCityName": "Perth",
    "countryCode": "AU",
    "name": "Western Australia",
    "timeZone": "Australia/Perth"
  },
  {
    "id": "168",
    "stateCode": "VIC",
    "capitalCityName": "Melbourne",
    "countryCode": "AU",
    "name": "Victoria",
    "timeZone": "Australia/Melbourne"
  },
  {
    "id": "169",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AT",
    "name": "Burgenland",
    "timeZone": "Europe/Vienna"
  },
  {
    "id": "170",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AT",
    "name": "Karnten",
    "timeZone": "Europe/Vienna"
  },
  {
    "id": "171",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AT",
    "name": "Niederosterreich",
    "timeZone": "Europe/Vienna"
  },
  {
    "id": "172",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AT",
    "name": "Oberosterreich",
    "timeZone": "Europe/Vienna"
  },
  {
    "id": "173",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AT",
    "name": "Salzburg",
    "timeZone": "Europe/Vienna"
  },
  {
    "id": "174",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AT",
    "name": "Steiermark",
    "timeZone": "Europe/Vienna"
  },
  {
    "id": "175",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AT",
    "name": "Tirol",
    "timeZone": "Europe/Vienna"
  },
  {
    "id": "176",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AT",
    "name": "Wien",
    "timeZone": "Europe/Vienna"
  },
  {
    "id": "177",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AT",
    "name": "Vorarlberg",
    "timeZone": "Europe/Vienna"
  },
  {
    "id": "178",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AZ",
    "name": "Azerbaijan",
    "timeZone": "Asia/Baku"
  },
  {
    "id": "179",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Acklins and Crooke",
    "timeZone": "America/Nassau"
  },
  {
    "id": "180",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Bimini",
    "timeZone": "America/Nassau"
  },
  {
    "id": "181",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Cat Island",
    "timeZone": "America/Nassau"
  },
  {
    "id": "182",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Exuma",
    "timeZone": "America/Nassau"
  },
  {
    "id": "183",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Freeport",
    "timeZone": "America/Nassau"
  },
  {
    "id": "184",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Fresh Creek",
    "timeZone": "America/Nassau"
  },
  {
    "id": "185",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Governor's Harbour",
    "timeZone": "America/Nassau"
  },
  {
    "id": "186",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Green Turtle Cay",
    "timeZone": "America/Nassau"
  },
  {
    "id": "187",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Harbour Island",
    "timeZone": "America/Nassau"
  },
  {
    "id": "188",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "High Rock",
    "timeZone": "America/Nassau"
  },
  {
    "id": "189",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Inagua",
    "timeZone": "America/Nassau"
  },
  {
    "id": "190",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Kemps Bay",
    "timeZone": "America/Nassau"
  },
  {
    "id": "191",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Long Island",
    "timeZone": "America/Nassau"
  },
  {
    "id": "192",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Marsh Harbour",
    "timeZone": "America/Nassau"
  },
  {
    "id": "193",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Mayaguana",
    "timeZone": "America/Nassau"
  },
  {
    "id": "194",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "New Providence",
    "timeZone": "America/Nassau"
  },
  {
    "id": "195",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Nichollstown",
    "timeZone": "America/Nassau"
  },
  {
    "id": "196",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Ragged Island",
    "timeZone": "America/Nassau"
  },
  {
    "id": "197",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Rock Sound",
    "timeZone": "America/Nassau"
  },
  {
    "id": "198",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "San Salvador",
    "timeZone": "America/Nassau"
  },
  {
    "id": "199",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BS",
    "name": "Sandy Point",
    "timeZone": "America/Nassau"
  },
  {
    "id": "200",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BH",
    "name": "Al Hadd",
    "timeZone": "Asia/Bahrain"
  },
  {
    "id": "201",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BH",
    "name": "Al Manamah",
    "timeZone": "Asia/Bahrain"
  },
  {
    "id": "202",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BH",
    "name": "Al Mintaqah al Gha",
    "timeZone": "Asia/Bahrain"
  },
  {
    "id": "203",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BH",
    "name": "Al Mintaqah al Wus",
    "timeZone": "Asia/Bahrain"
  },
  {
    "id": "204",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BH",
    "name": "Al Mintaqah ash Sh",
    "timeZone": "Asia/Bahrain"
  },
  {
    "id": "205",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BH",
    "name": "Al Muharraq",
    "timeZone": "Asia/Bahrain"
  },
  {
    "id": "206",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BH",
    "name": "Ar Rifa wa al Min",
    "timeZone": "Asia/Bahrain"
  },
  {
    "id": "207",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BH",
    "name": "Jidd Hafs",
    "timeZone": "Asia/Bahrain"
  },
  {
    "id": "208",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BH",
    "name": "Madinat Hamad",
    "timeZone": "Asia/Bahrain"
  },
  {
    "id": "209",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BH",
    "name": "Madinat Isa",
    "timeZone": "Asia/Bahrain"
  },
  {
    "id": "210",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BH",
    "name": "Mintaqat Juzur Haw",
    "timeZone": "Asia/Bahrain"
  },
  {
    "id": "211",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BH",
    "name": "Sitrah",
    "timeZone": "Asia/Bahrain"
  },
  {
    "id": "212",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Bagerhat",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "213",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Bandarban",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "214",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Barguna",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "215",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Barisal",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "216",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Bhola",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "217",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Bogra",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "218",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Brahmanbaria",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "219",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Chandpur",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "220",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Chapai Nawabganj",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "221",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Chattagram",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "222",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Chuadanga",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "223",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Comilla",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "224",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Cox's Bazar",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "225",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Dhaka",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "226",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Dinajpur",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "227",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Faridpur",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "228",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Feni",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "229",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Gaibandha",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "230",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Gazipur",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "231",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Gopalganj",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "232",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Habiganj",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "233",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Jaipurhat",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "234",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Jamalpur",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "235",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Jessore",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "236",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Jhalakati",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "237",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Jhenaidah",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "238",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Khagrachari",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "239",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Khulna",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "240",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Kishorganj",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "241",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Kurigram",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "242",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Kushtia",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "243",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Laksmipur",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "244",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Lalmonirhat",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "245",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Madaripur",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "246",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Magura",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "247",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Manikganj",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "248",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Meherpur",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "249",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Moulavibazar",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "250",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Munshiganj",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "251",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Mymensingh",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "252",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Naogaon",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "253",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Narail",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "254",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Narayanganj",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "255",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Narsingdi",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "256",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Nator",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "257",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Netrakona",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "258",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Nilphamari",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "259",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Noakhali",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "260",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Pabna",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "261",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Panchagar",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "262",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Parbattya Chattagr",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "263",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Patuakhali",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "264",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Pirojpur",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "265",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Rajbari",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "266",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Rajshahi",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "267",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Rangpur",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "268",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Satkhira",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "269",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Shariyatpur",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "270",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Sherpur",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "271",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Sirajganj",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "272",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Sunamganj",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "273",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Sylhet",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "274",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Tangail",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "275",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BD",
    "name": "Thakurgaon",
    "timeZone": "Asia/Dhaka"
  },
  {
    "id": "276",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BB",
    "name": "Christ Church",
    "timeZone": "America/Barbados"
  },
  {
    "id": "277",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BB",
    "name": "Saint Andrew",
    "timeZone": "America/Barbados"
  },
  {
    "id": "278",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BB",
    "name": "Saint George",
    "timeZone": "America/Barbados"
  },
  {
    "id": "279",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BB",
    "name": "Saint James",
    "timeZone": "America/Barbados"
  },
  {
    "id": "280",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BB",
    "name": "Saint John",
    "timeZone": "America/Barbados"
  },
  {
    "id": "281",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BB",
    "name": "Saint Joseph",
    "timeZone": "America/Barbados"
  },
  {
    "id": "282",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BB",
    "name": "Saint Lucy",
    "timeZone": "America/Barbados"
  },
  {
    "id": "283",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BB",
    "name": "Saint Michael",
    "timeZone": "America/Barbados"
  },
  {
    "id": "284",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BB",
    "name": "Saint Peter",
    "timeZone": "America/Barbados"
  },
  {
    "id": "285",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BB",
    "name": "Saint Philip",
    "timeZone": "America/Barbados"
  },
  {
    "id": "286",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BB",
    "name": "Saint Thomas",
    "timeZone": "America/Barbados"
  },
  {
    "id": "287",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BY",
    "name": "Belarus",
    "timeZone": "Europe/Minsk"
  },
  {
    "id": "288",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BE",
    "name": "Antwerpen",
    "timeZone": "Europe/Brussels"
  },
  {
    "id": "289",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BE",
    "name": "Brabant",
    "timeZone": "Europe/Brussels"
  },
  {
    "id": "290",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BE",
    "name": "Hainaut",
    "timeZone": "Europe/Brussels"
  },
  {
    "id": "291",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BE",
    "name": "Liege",
    "timeZone": "Europe/Brussels"
  },
  {
    "id": "292",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BE",
    "name": "Limburg",
    "timeZone": "Europe/Brussels"
  },
  {
    "id": "293",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BE",
    "name": "Luxembourg",
    "timeZone": "Europe/Brussels"
  },
  {
    "id": "294",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BE",
    "name": "Namur",
    "timeZone": "Europe/Brussels"
  },
  {
    "id": "295",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BE",
    "name": "Oost-Vlaanderen",
    "timeZone": "Europe/Brussels"
  },
  {
    "id": "296",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BE",
    "name": "West-Vlaanderen",
    "timeZone": "Europe/Brussels"
  },
  {
    "id": "297",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BZ",
    "name": "Belize",
    "timeZone": "America/Belize"
  },
  {
    "id": "298",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BZ",
    "name": "Cayo",
    "timeZone": "America/Belize"
  },
  {
    "id": "299",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BZ",
    "name": "Corozal",
    "timeZone": "America/Belize"
  },
  {
    "id": "300",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BZ",
    "name": "Orange Walk",
    "timeZone": "America/Belize"
  },
  {
    "id": "301",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BZ",
    "name": "Stann Creek",
    "timeZone": "America/Belize"
  },
  {
    "id": "302",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BZ",
    "name": "Toledo",
    "timeZone": "America/Belize"
  },
  {
    "id": "303",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BJ",
    "name": "Atakora",
    "timeZone": "Africa/Porto-Novo"
  },
  {
    "id": "304",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BJ",
    "name": "Atlantique",
    "timeZone": "Africa/Porto-Novo"
  },
  {
    "id": "305",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BJ",
    "name": "Borgou",
    "timeZone": "Africa/Porto-Novo"
  },
  {
    "id": "306",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BJ",
    "name": "Mono",
    "timeZone": "Africa/Porto-Novo"
  },
  {
    "id": "307",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BJ",
    "name": "Oueme",
    "timeZone": "Africa/Porto-Novo"
  },
  {
    "id": "308",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BJ",
    "name": "Zou",
    "timeZone": "Africa/Porto-Novo"
  },
  {
    "id": "309",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BM",
    "name": "Devonshire",
    "timeZone": "Atlantic/Bermuda"
  },
  {
    "id": "310",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BM",
    "name": "Hamilton",
    "timeZone": "Atlantic/Bermuda"
  },
  {
    "id": "311",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BM",
    "name": "Hamilton",
    "timeZone": "Atlantic/Bermuda"
  },
  {
    "id": "312",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BM",
    "name": "Paget",
    "timeZone": "Atlantic/Bermuda"
  },
  {
    "id": "313",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BM",
    "name": "Pembroke",
    "timeZone": "Atlantic/Bermuda"
  },
  {
    "id": "314",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BM",
    "name": "Saint George",
    "timeZone": "Atlantic/Bermuda"
  },
  {
    "id": "315",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BM",
    "name": "Saint George's",
    "timeZone": "Atlantic/Bermuda"
  },
  {
    "id": "316",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BM",
    "name": "Sandys",
    "timeZone": "Atlantic/Bermuda"
  },
  {
    "id": "317",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BM",
    "name": "Smiths",
    "timeZone": "Atlantic/Bermuda"
  },
  {
    "id": "318",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BM",
    "name": "Southampton",
    "timeZone": "Atlantic/Bermuda"
  },
  {
    "id": "319",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BM",
    "name": "Warwick",
    "timeZone": "Atlantic/Bermuda"
  },
  {
    "id": "320",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Bumthang",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "321",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Chhukha",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "322",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Chirang",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "323",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Daga",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "324",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Geylegphug",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "325",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Ha",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "326",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Lhuntshi",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "327",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Mongar",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "328",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Paro",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "329",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Pemagatsel",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "330",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Punakha",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "331",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Samchi",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "332",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Samdrup",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "333",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Shemgang",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "334",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Tashigang",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "335",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Thimphu",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "336",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Tongsa",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "337",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BT",
    "name": "Wangdi Phodrang",
    "timeZone": "Asia/Thimphu"
  },
  {
    "id": "338",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BO",
    "name": "Chuquisaca",
    "timeZone": "America/La_Paz"
  },
  {
    "id": "339",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BO",
    "name": "Cochabamba",
    "timeZone": "America/La_Paz"
  },
  {
    "id": "340",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BO",
    "name": "El Beni",
    "timeZone": "America/La_Paz"
  },
  {
    "id": "341",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BO",
    "name": "La Paz",
    "timeZone": "America/La_Paz"
  },
  {
    "id": "342",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BO",
    "name": "Oruro",
    "timeZone": "America/La_Paz"
  },
  {
    "id": "343",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BO",
    "name": "Pando",
    "timeZone": "America/La_Paz"
  },
  {
    "id": "344",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BO",
    "name": "Potosi",
    "timeZone": "America/La_Paz"
  },
  {
    "id": "345",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BO",
    "name": "Santa Cruz",
    "timeZone": "America/La_Paz"
  },
  {
    "id": "346",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BO",
    "name": "Tarija",
    "timeZone": "America/La_Paz"
  },
  {
    "id": "347",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BA",
    "name": "Boznia an Herzegovina",
    "timeZone": "Europe/Sarajevo"
  },
  {
    "id": "348",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BW",
    "name": "Central",
    "timeZone": "Africa/Gaborone"
  },
  {
    "id": "349",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BW",
    "name": "Chobe",
    "timeZone": "Africa/Gaborone"
  },
  {
    "id": "350",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BW",
    "name": "Ghanzi",
    "timeZone": "Africa/Gaborone"
  },
  {
    "id": "351",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BW",
    "name": "Kgalagadi",
    "timeZone": "Africa/Gaborone"
  },
  {
    "id": "352",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BW",
    "name": "Kgatleng",
    "timeZone": "Africa/Gaborone"
  },
  {
    "id": "353",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BW",
    "name": "Kweneng",
    "timeZone": "Africa/Gaborone"
  },
  {
    "id": "354",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BW",
    "name": "Ngamiland",
    "timeZone": "Africa/Gaborone"
  },
  {
    "id": "355",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BW",
    "name": "North-East",
    "timeZone": "Africa/Gaborone"
  },
  {
    "id": "356",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BW",
    "name": "South-East",
    "timeZone": "Africa/Gaborone"
  },
  {
    "id": "357",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BW",
    "name": "Southern",
    "timeZone": "Africa/Gaborone"
  },
  {
    "id": "358",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BV",
    "name": "Bouvet Island"
  },
  {
    "id": "359",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Acre",
    "timeZone": "America/Rio_Branco"
  },
  {
    "id": "360",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Alagoas",
    "timeZone": "America/Maceio"
  },
  {
    "id": "361",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Amapa",
    "timeZone": "America/Manaus"
  },
  {
    "id": "362",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Amazonas",
    "timeZone": "America/Manaus"
  },
  {
    "id": "363",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Bahia",
    "timeZone": "America/Bahia"
  },
  {
    "id": "364",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Ceara",
    "timeZone": "America/Fortaleza"
  },
  {
    "id": "365",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Distrito Federal",
    "timeZone": "America/Sao_Paulo"
  },
  {
    "id": "366",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Espirito Santo",
    "timeZone": "America/Sao_Paulo"
  },
  {
    "id": "367",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Goias",
    "timeZone": "America/Sao_Paulo"
  },
  {
    "id": "368",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Maranhao",
    "timeZone": "America/Manaus"
  },
  {
    "id": "369",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Mato Grosso",
    "timeZone": "America/Cuiaba"
  },
  {
    "id": "370",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Mato Grosso do Sul",
    "timeZone": "America/Campo_Grande"
  },
  {
    "id": "371",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Minas Gerais",
    "timeZone": "America/Sao_Paulo"
  },
  {
    "id": "372",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Para",
    "timeZone": "America/Belem"
  },
  {
    "id": "373",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Paraiba",
    "timeZone": "America/Manaus"
  },
  {
    "id": "374",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Parana",
    "timeZone": "America/Sao_Paulo"
  },
  {
    "id": "375",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Pernambuco",
    "timeZone": "America/Recife"
  },
  {
    "id": "376",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Piaui",
    "timeZone": "America/Manaus"
  },
  {
    "id": "377",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Rio de Janeiro",
    "timeZone": "America/Sao_Paulo"
  },
  {
    "id": "378",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Rio Grande do Nort",
    "timeZone": "America/Manaus"
  },
  {
    "id": "379",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Rio Grande do Sul",
    "timeZone": "America/Sao_Paulo"
  },
  {
    "id": "380",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Rondonia",
    "timeZone": "America/Porto_Velho"
  },
  {
    "id": "381",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Roraima",
    "timeZone": "America/Boa_Vista"
  },
  {
    "id": "382",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Santa Catarina",
    "timeZone": "America/Sao_Paulo"
  },
  {
    "id": "383",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Sao Paulo",
    "timeZone": "America/Sao_Paulo"
  },
  {
    "id": "384",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Sergipe",
    "timeZone": "America/Manaus"
  },
  {
    "id": "385",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BR",
    "name": "Tocantins",
    "timeZone": "America/Araguaina"
  },
  {
    "id": "386",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IO",
    "name": "British Indian Ocean Territory",
    "timeZone": "Indian/Chagos"
  },
  {
    "id": "387",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BN",
    "name": "Belait",
    "timeZone": "Asia/Brunei"
  },
  {
    "id": "388",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BN",
    "name": "Brunei and Muara",
    "timeZone": "Asia/Brunei"
  },
  {
    "id": "389",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BN",
    "name": "Temburong",
    "timeZone": "Asia/Brunei"
  },
  {
    "id": "390",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BN",
    "name": "Tutong",
    "timeZone": "Asia/Brunei"
  },
  {
    "id": "391",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BG",
    "name": "Burgas",
    "timeZone": "Europe/Sofia"
  },
  {
    "id": "392",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BG",
    "name": "Grad Sofiya",
    "timeZone": "Europe/Sofia"
  },
  {
    "id": "393",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BG",
    "name": "Khaskovo",
    "timeZone": "Europe/Sofia"
  },
  {
    "id": "394",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BG",
    "name": "Lovech",
    "timeZone": "Europe/Sofia"
  },
  {
    "id": "395",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BG",
    "name": "Mikhaylovgrad",
    "timeZone": "Europe/Sofia"
  },
  {
    "id": "396",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BG",
    "name": "Plovdiv",
    "timeZone": "Europe/Sofia"
  },
  {
    "id": "397",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BG",
    "name": "Razgrad",
    "timeZone": "Europe/Sofia"
  },
  {
    "id": "398",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BG",
    "name": "Sofiya",
    "timeZone": "Europe/Sofia"
  },
  {
    "id": "399",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BG",
    "name": "Varna",
    "timeZone": "Europe/Sofia"
  },
  {
    "id": "400",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Bam",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "401",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Bazega",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "402",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Bougouriba",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "403",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Boulgou",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "404",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Boulkiemde",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "405",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Ganzourgou",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "406",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Gnagna",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "407",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Gourma",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "408",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Houet",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "409",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Kadiogo",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "410",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Kenedougou",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "411",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Komoe",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "412",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Kossi",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "413",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Kouritenga",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "414",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Mouhoun",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "415",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Namentenga",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "416",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Naouri",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "417",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Oubritenga",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "418",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Oudalan",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "419",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Passore",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "420",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Poni",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "421",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Sanguie",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "422",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Sanmatenga",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "423",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Seno",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "424",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Sissili",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "425",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Soum",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "426",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Sourou",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "427",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Tapoa",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "428",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Yatenga",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "429",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BF",
    "name": "Zoundweogo",
    "timeZone": "Africa/Ouagadougou"
  },
  {
    "id": "430",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Bubanza",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "431",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Bujumbura",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "432",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Bururi",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "433",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Cankuzo",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "434",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Cibitoke",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "435",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Gitega",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "436",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Karuzi",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "437",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Kayanza",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "438",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Kirundo",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "439",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Makamba",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "440",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Muramvya",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "441",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Muyinga",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "442",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Ngozi",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "443",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Rutana",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "444",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "BI",
    "name": "Ruyigi",
    "timeZone": "Africa/Bujumbura"
  },
  {
    "id": "445",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Batdambang",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "446",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Kampong Cham",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "447",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Kampong Chhnang",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "448",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Kampong Spoe",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "449",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Kampong Thum",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "450",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Kampot",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "451",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Kandal",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "452",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Kaoh Kong",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "453",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Kracheh",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "454",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Mondol Kiri",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "455",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Phnum Penh",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "456",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Pouthisat",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "457",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Preah Vihear",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "458",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Prey Veng",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "459",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Rotanokiri",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "460",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Siemreab-Otdar Mea",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "461",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Stoeng Treng",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "462",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Svay Rieng",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "463",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KH",
    "name": "Takev",
    "timeZone": "Asia/Phnom_Penh"
  },
  {
    "id": "464",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CA",
    "name": "Alberta",
    "timeZone": "America/Edmonton"
  },
  {
    "id": "465",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CA",
    "name": "British Columbia",
    "timeZone": "America/Vancouver"
  },
  {
    "id": "466",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CA",
    "name": "Manitoba",
    "timeZone": "America/Winnipeg"
  },
  {
    "id": "467",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CA",
    "name": "New Brunswick",
    "timeZone": "America/Halifax"
  },
  {
    "id": "468",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CA",
    "name": "Newfoundland",
    "timeZone": "America/St_Johns"
  },
  {
    "id": "469",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CA",
    "name": "Northwest Territor",
    "timeZone": "America/Yellowknife"
  },
  {
    "id": "470",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CA",
    "name": "Nova Scotia",
    "timeZone": "America/Halifax"
  },
  {
    "id": "471",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CA",
    "name": "Ontario",
    "timeZone": "America/Toronto"
  },
  {
    "id": "472",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CA",
    "name": "Prince Edward Isla",
    "timeZone": "America/Halifax"
  },
  {
    "id": "473",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CA",
    "name": "Quebec",
    "timeZone": "America/Blanc-Sablon"
  },
  {
    "id": "474",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CA",
    "name": "Saskatchewan",
    "timeZone": "America/Regina"
  },
  {
    "id": "475",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CA",
    "name": "Yukon Territory",
    "timeZone": "America/Whitehorse"
  },
  {
    "id": "476",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CL",
    "name": "Aisen del General",
    "timeZone": "America/Santiago"
  },
  {
    "id": "477",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CL",
    "name": "Antofagasta",
    "timeZone": "America/Santiago"
  },
  {
    "id": "478",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CL",
    "name": "Araucania",
    "timeZone": "America/Santiago"
  },
  {
    "id": "479",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CL",
    "name": "Atacama",
    "timeZone": "America/Santiago"
  },
  {
    "id": "480",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CL",
    "name": "Bio-Bio",
    "timeZone": "America/Santiago"
  },
  {
    "id": "481",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CL",
    "name": "Coquimbo",
    "timeZone": "America/Santiago"
  },
  {
    "id": "482",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CL",
    "name": "Libertador General",
    "timeZone": "America/Santiago"
  },
  {
    "id": "483",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CL",
    "name": "Los Lagos",
    "timeZone": "America/Santiago"
  },
  {
    "id": "484",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CL",
    "name": "Magallanes y de la",
    "timeZone": "America/Santiago"
  },
  {
    "id": "485",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CL",
    "name": "Maule",
    "timeZone": "America/Santiago"
  },
  {
    "id": "486",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CL",
    "name": "Region Metropolita",
    "timeZone": "America/Santiago"
  },
  {
    "id": "487",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CL",
    "name": "Tarapaca",
    "timeZone": "America/Santiago"
  },
  {
    "id": "488",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CL",
    "name": "Valparaiso",
    "timeZone": "America/Santiago"
  },
  {
    "id": "489",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Amazonas",
    "timeZone": "America/Bogota"
  },
  {
    "id": "490",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Antioquia",
    "timeZone": "America/Bogota"
  },
  {
    "id": "491",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Arauca",
    "timeZone": "America/Bogota"
  },
  {
    "id": "492",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Atlantico",
    "timeZone": "America/Bogota"
  },
  {
    "id": "493",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Bolivar",
    "timeZone": "America/Bogota"
  },
  {
    "id": "494",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Boyaca",
    "timeZone": "America/Bogota"
  },
  {
    "id": "495",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Caldas",
    "timeZone": "America/Bogota"
  },
  {
    "id": "496",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Caqueta",
    "timeZone": "America/Bogota"
  },
  {
    "id": "497",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Casanare",
    "timeZone": "America/Bogota"
  },
  {
    "id": "498",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Cauca",
    "timeZone": "America/Bogota"
  },
  {
    "id": "499",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Cesar",
    "timeZone": "America/Bogota"
  },
  {
    "id": "500",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Choco",
    "timeZone": "America/Bogota"
  },
  {
    "id": "501",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Cordoba",
    "timeZone": "America/Bogota"
  },
  {
    "id": "502",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Cundinamarca",
    "timeZone": "America/Bogota"
  },
  {
    "id": "503",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Distrito Especial",
    "timeZone": "America/Bogota"
  },
  {
    "id": "504",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Guainia",
    "timeZone": "America/Bogota"
  },
  {
    "id": "505",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Guaviare",
    "timeZone": "America/Bogota"
  },
  {
    "id": "506",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Huila",
    "timeZone": "America/Bogota"
  },
  {
    "id": "507",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "La Guajira",
    "timeZone": "America/Bogota"
  },
  {
    "id": "508",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Magdalena",
    "timeZone": "America/Bogota"
  },
  {
    "id": "509",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Meta",
    "timeZone": "America/Bogota"
  },
  {
    "id": "510",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Narino",
    "timeZone": "America/Bogota"
  },
  {
    "id": "511",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Norte de Santander",
    "timeZone": "America/Bogota"
  },
  {
    "id": "512",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Putumayo",
    "timeZone": "America/Bogota"
  },
  {
    "id": "513",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Quindio",
    "timeZone": "America/Bogota"
  },
  {
    "id": "514",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Risaralda",
    "timeZone": "America/Bogota"
  },
  {
    "id": "515",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "San Andres y Provi",
    "timeZone": "America/Bogota"
  },
  {
    "id": "516",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Santander",
    "timeZone": "America/Bogota"
  },
  {
    "id": "517",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Sucre",
    "timeZone": "America/Bogota"
  },
  {
    "id": "518",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Tolima",
    "timeZone": "America/Bogota"
  },
  {
    "id": "519",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Valle del Cauca",
    "timeZone": "America/Bogota"
  },
  {
    "id": "520",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Vaupes",
    "timeZone": "America/Bogota"
  },
  {
    "id": "521",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CO",
    "name": "Vichada",
    "timeZone": "America/Bogota"
  },
  {
    "id": "522",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CR",
    "name": "Alajuela",
    "timeZone": "America/Costa_Rica"
  },
  {
    "id": "523",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CR",
    "name": "Cartago",
    "timeZone": "America/Costa_Rica"
  },
  {
    "id": "524",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CR",
    "name": "Guanacaste",
    "timeZone": "America/Costa_Rica"
  },
  {
    "id": "525",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CR",
    "name": "Heredia",
    "timeZone": "America/Costa_Rica"
  },
  {
    "id": "526",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CR",
    "name": "Limon",
    "timeZone": "America/Costa_Rica"
  },
  {
    "id": "527",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CR",
    "name": "Puntarenas",
    "timeZone": "America/Costa_Rica"
  },
  {
    "id": "528",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CR",
    "name": "San Jose",
    "timeZone": "America/Costa_Rica"
  },
  {
    "id": "529",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HR",
    "name": "Croatia",
    "timeZone": "Europe/Zagreb"
  },
  {
    "id": "530",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Camaguey",
    "timeZone": "America/Havana"
  },
  {
    "id": "531",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Ciego de Avila",
    "timeZone": "America/Havana"
  },
  {
    "id": "532",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Cienfuegos",
    "timeZone": "America/Havana"
  },
  {
    "id": "533",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Ciudad de la Haban",
    "timeZone": "America/Havana"
  },
  {
    "id": "534",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Granma",
    "timeZone": "America/Havana"
  },
  {
    "id": "535",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Guantanamo",
    "timeZone": "America/Havana"
  },
  {
    "id": "536",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Holguin",
    "timeZone": "America/Havana"
  },
  {
    "id": "537",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Isla de la Juventu",
    "timeZone": "America/Havana"
  },
  {
    "id": "538",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "La Habana",
    "timeZone": "America/Havana"
  },
  {
    "id": "539",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Las Tunas",
    "timeZone": "America/Havana"
  },
  {
    "id": "540",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Matanzas",
    "timeZone": "America/Havana"
  },
  {
    "id": "541",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Pinar del Rio",
    "timeZone": "America/Havana"
  },
  {
    "id": "542",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Sancti Spiritus",
    "timeZone": "America/Havana"
  },
  {
    "id": "543",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Santiago de Cuba",
    "timeZone": "America/Havana"
  },
  {
    "id": "544",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CU",
    "name": "Villa Clara",
    "timeZone": "America/Havana"
  },
  {
    "id": "545",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CY",
    "name": "Famagusta",
    "timeZone": "Asia/Nicosia"
  },
  {
    "id": "546",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CY",
    "name": "Kyrenia",
    "timeZone": "Asia/Nicosia"
  },
  {
    "id": "547",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CY",
    "name": "Larnaca",
    "timeZone": "Asia/Nicosia"
  },
  {
    "id": "548",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CY",
    "name": "Limassol",
    "timeZone": "Asia/Nicosia"
  },
  {
    "id": "549",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CY",
    "name": "Nicosia",
    "timeZone": "Asia/Nicosia"
  },
  {
    "id": "550",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CY",
    "name": "Paphos",
    "timeZone": "Asia/Nicosia"
  },
  {
    "id": "551",
    "stateCode": "CZ",
    "capitalCityName": null,
    "countryCode": "CZ",
    "name": "Czech Republic",
    "timeZone": "Europe/Prague"
  },
  {
    "id": "552",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Arhus",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "553",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Bornholm",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "554",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Frederiksborg",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "555",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Fyn",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "556",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Kobenhavn",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "557",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Nordjylland",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "558",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Ribe",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "559",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Ringkobing",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "560",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Roskilde",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "561",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Sonderjylland",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "562",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Staden Kobenhavn",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "563",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Storstrom",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "564",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Vejle",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "565",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Vestsjalland",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "566",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DK",
    "name": "Viborg",
    "timeZone": "Europe/Copenhagen"
  },
  {
    "id": "567",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Azua",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "568",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Baoruco",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "569",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Barahona",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "570",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Dajabon",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "571",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Distrito Nacional",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "572",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Duarte",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "573",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "El Seibo",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "574",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Elias Pina",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "575",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Espaillat",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "576",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Hato Mayor",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "577",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Independencia",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "578",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "La Altagracia",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "579",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "La Romana",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "580",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "La Vega",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "581",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Maria Trinidad San",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "582",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Monsenor Nouel",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "583",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Monte Cristi",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "584",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Monte Plata",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "585",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Pedernales",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "586",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Peravia",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "587",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Puerto Plata",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "588",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Salcedo",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "589",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Samana",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "590",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "San Cristobal",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "591",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "San Juan",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "592",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "San Pedro De Macor",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "593",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Sanchez Ramirez",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "594",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Santiago",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "595",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Santiago Rodriguez",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "596",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DO",
    "name": "Valverde",
    "timeZone": "America/Santo_Domingo"
  },
  {
    "id": "597",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Azuay",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "598",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Bolivar",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "599",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Canar",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "600",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Carchi",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "601",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Chimborazo",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "602",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Cotopaxi",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "603",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "El Oro",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "604",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Esmeraldas",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "605",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Galapagos",
    "timeZone": "Pacific/Galapagos"
  },
  {
    "id": "606",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Guayas",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "607",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Imbabura",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "608",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Loja",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "609",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Los Rios",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "610",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Manabi",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "611",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Morona-Santiago",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "612",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Napo",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "613",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Pastaza",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "614",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Pichincha",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "615",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Sucumbios",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "616",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Tungurahua",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "617",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EC",
    "name": "Zamora-Chinchipe",
    "timeZone": "America/Guayaquil"
  },
  {
    "id": "618",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Ad Daqahliyah",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "619",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Al Bahr al Ahmar",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "620",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Al Buhayrah",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "621",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Al Fayyum",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "622",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Al Gharbiyah",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "623",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Al Iskandariyah",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "624",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Al Isma'iliyah",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "625",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Al Jizah",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "626",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Al Minufiyah",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "627",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Al Minya",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "628",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Al Qahirah",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "629",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Al Qalyubiyah",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "630",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Al Wadi al Jadid",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "631",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "As Suways",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "632",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Ash Sharqiyah",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "633",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Aswan",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "634",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Asyut",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "635",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Bani Suwayf",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "636",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Bur Sa'id",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "637",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Dumyat",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "638",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Janub Sina",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "639",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Kafr ash Shaykh",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "640",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Matruh",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "641",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Qina",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "642",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Shamal Sina",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "643",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EG",
    "name": "Suhaj",
    "timeZone": "Africa/Cairo"
  },
  {
    "id": "644",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "Ahuachapan",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "645",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "Cabanas",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "646",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "Chalatenango",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "647",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "Cuscatlan",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "648",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "La Libertad",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "649",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "La Paz",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "650",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "La Union",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "651",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "Morazan",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "652",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "San Miguel",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "653",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "San Salvador",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "654",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "San Vicente",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "655",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "Santa Ana",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "656",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "Sonsonate",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "657",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SV",
    "name": "Usulutan",
    "timeZone": "America/El_Salvador"
  },
  {
    "id": "658",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GQ",
    "name": "Annobon",
    "timeZone": "Africa/Malabo"
  },
  {
    "id": "659",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GQ",
    "name": "Bioko Norte",
    "timeZone": "Africa/Malabo"
  },
  {
    "id": "660",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GQ",
    "name": "Bioko Sur",
    "timeZone": "Africa/Malabo"
  },
  {
    "id": "661",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GQ",
    "name": "Centro Sur",
    "timeZone": "Africa/Malabo"
  },
  {
    "id": "662",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GQ",
    "name": "Kie-Ntem",
    "timeZone": "Africa/Malabo"
  },
  {
    "id": "663",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GQ",
    "name": "Litoral",
    "timeZone": "Africa/Malabo"
  },
  {
    "id": "664",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GQ",
    "name": "Wele-Nzas",
    "timeZone": "Africa/Malabo"
  },
  {
    "id": "665",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Harjumaa"
  },
  {
    "id": "666",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Hiiumaa"
  },
  {
    "id": "667",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Ida-Virumaa"
  },
  {
    "id": "668",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Jarvamaa"
  },
  {
    "id": "669",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Jogevamaa"
  },
  {
    "id": "670",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Kohtla-Jarve"
  },
  {
    "id": "671",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Laanemaa"
  },
  {
    "id": "672",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Laane-Virumaa"
  },
  {
    "id": "673",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Narva"
  },
  {
    "id": "674",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Parnu"
  },
  {
    "id": "675",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Parnumaa"
  },
  {
    "id": "676",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Polvamaa"
  },
  {
    "id": "677",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Raplamaa"
  },
  {
    "id": "678",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Saaremaa"
  },
  {
    "id": "679",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Sillamae"
  },
  {
    "id": "680",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Tallinn"
  },
  {
    "id": "681",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Tartu"
  },
  {
    "id": "682",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Tartumaa"
  },
  {
    "id": "683",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Valgamaa"
  },
  {
    "id": "684",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Viljandimaa"
  },
  {
    "id": "685",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "EE",
    "name": "Vorumaa"
  },
  {
    "id": "686",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Adis Abeba",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "687",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Arsi",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "688",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Asosa",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "689",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Bale",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "690",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Borena",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "691",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Debub Gonder",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "692",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Debub Shewa",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "693",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Debub Welo",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "694",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Dire Dawa",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "695",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Gambela",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "696",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Gamo Gofa",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "697",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Ilubabor",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "698",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Kefa",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "699",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Metekel",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "700",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Mirab Gojam",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "701",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Mirab Harerge",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "702",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Mirab Shewa",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "703",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Misrak Gojam",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "704",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Misrak Harerge",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "705",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Nazret",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "706",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Ogaden",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "707",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Omo",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "708",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Semen Gonder",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "709",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Semen Shewa",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "710",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Semen Welo",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "711",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Sidamo",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "712",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Tigray",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "713",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ET",
    "name": "Welega",
    "timeZone": "Africa/Addis_Ababa"
  },
  {
    "id": "714",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FO",
    "name": "Faroe Islands",
    "timeZone": "Atlantic/Faroe"
  },
  {
    "id": "715",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FJ",
    "name": "Central",
    "timeZone": "Pacific/Fiji"
  },
  {
    "id": "716",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FJ",
    "name": "Eastern",
    "timeZone": "Pacific/Fiji"
  },
  {
    "id": "717",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FJ",
    "name": "Northern",
    "timeZone": "Pacific/Fiji"
  },
  {
    "id": "718",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FJ",
    "name": "Rotuma",
    "timeZone": "Pacific/Fiji"
  },
  {
    "id": "719",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FJ",
    "name": "Western",
    "timeZone": "Pacific/Fiji"
  },
  {
    "id": "720",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FI",
    "name": "Ahvenanmaa",
    "timeZone": "Europe/Helsinki"
  },
  {
    "id": "721",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FI",
    "name": "Hame",
    "timeZone": "Europe/Helsinki"
  },
  {
    "id": "722",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FI",
    "name": "Keski-Suomi",
    "timeZone": "Europe/Helsinki"
  },
  {
    "id": "723",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FI",
    "name": "Kuopio",
    "timeZone": "Europe/Helsinki"
  },
  {
    "id": "724",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FI",
    "name": "Kymi",
    "timeZone": "Europe/Helsinki"
  },
  {
    "id": "725",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FI",
    "name": "Lappi",
    "timeZone": "Europe/Helsinki"
  },
  {
    "id": "726",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FI",
    "name": "Mikkeli",
    "timeZone": "Europe/Helsinki"
  },
  {
    "id": "727",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FI",
    "name": "Oulu",
    "timeZone": "Europe/Helsinki"
  },
  {
    "id": "728",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FI",
    "name": "Pohjois-Karjala",
    "timeZone": "Europe/Helsinki"
  },
  {
    "id": "729",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FI",
    "name": "Turku ja Pori",
    "timeZone": "Europe/Helsinki"
  },
  {
    "id": "730",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FI",
    "name": "Uusimaa",
    "timeZone": "Europe/Helsinki"
  },
  {
    "id": "731",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FI",
    "name": "Vaasa",
    "timeZone": "Europe/Helsinki"
  },
  {
    "id": "732",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Alsace",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "733",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Aquitaine",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "734",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Auvergne",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "735",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Basse-Normandie",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "736",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Bourgogne",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "737",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Bretagne",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "738",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Centre",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "739",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Champagne-Ardenne",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "740",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Corse",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "741",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Franche-Comte",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "742",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Haute-Normandie",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "743",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Ile-de-France",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "744",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Languedoc-Roussill",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "745",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Limousin",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "746",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Lorraine",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "747",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Midi-Pyrenees",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "748",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Nord-Pas-de-Calais",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "749",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Pays de la Loire",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "750",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Picardie",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "751",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Poitou-Charentes",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "752",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Provence-Alpes-Cot",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "753",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "FR",
    "name": "Rhone-Alpes",
    "timeZone": "Europe/Paris"
  },
  {
    "id": "754",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Baden-Wurttemberg",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "755",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Bayern",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "756",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Berlin",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "757",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Brandenburg",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "758",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Bremen",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "759",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Hamburg",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "760",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Hessen",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "761",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Mecklenburg-Vorpom",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "762",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Niedersachsen",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "763",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Nordrhein-Westfale",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "764",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Rheinland-Pfalz",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "765",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Saarland",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "766",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Sachsen",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "767",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Sachsen-Anhalt",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "768",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Schleswig-Holstein",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "769",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "DE",
    "name": "Thuringen",
    "timeZone": "Europe/Berlin"
  },
  {
    "id": "770",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GH",
    "name": "Ashanti",
    "timeZone": "Africa/Accra"
  },
  {
    "id": "771",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GH",
    "name": "Brong-Ahafo",
    "timeZone": "Africa/Accra"
  },
  {
    "id": "772",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GH",
    "name": "Central",
    "timeZone": "Africa/Accra"
  },
  {
    "id": "773",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GH",
    "name": "Eastern",
    "timeZone": "Africa/Accra"
  },
  {
    "id": "774",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GH",
    "name": "Greater Accra",
    "timeZone": "Africa/Accra"
  },
  {
    "id": "775",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GH",
    "name": "Northern",
    "timeZone": "Africa/Accra"
  },
  {
    "id": "776",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GH",
    "name": "Upper East",
    "timeZone": "Africa/Accra"
  },
  {
    "id": "777",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GH",
    "name": "Upper West",
    "timeZone": "Africa/Accra"
  },
  {
    "id": "778",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GH",
    "name": "Western",
    "timeZone": "Africa/Accra"
  },
  {
    "id": "779",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GH",
    "name": "Volta",
    "timeZone": "Africa/Accra"
  },
  {
    "id": "780",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Aitolia kai Akarna",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "781",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Akhaia",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "782",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Argolis",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "783",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Arkadhia",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "784",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Arta",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "785",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Attiki",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "786",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Dhodhekanisos",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "787",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Drama",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "788",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Evritania",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "789",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Evros",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "790",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Evvoia",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "791",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Florina",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "792",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Fokis",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "793",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Fthiotis",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "794",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Grevena",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "795",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Ilia",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "796",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Imathia",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "797",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Ioannina",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "798",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Iraklion",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "799",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Kardhitsa",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "800",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Kastoria",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "801",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Kavala",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "802",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Kefallinia",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "803",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Kerkira",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "804",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Khalkidhiki",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "805",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Khania",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "806",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Khios",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "807",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Kikladhes",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "808",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Kilkis",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "809",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Korinthia",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "810",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Kozani",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "811",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Lakonia",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "812",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Larisa",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "813",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Lasithi",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "814",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Lesvos",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "815",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Levkas",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "816",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Magnisia",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "817",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Messinia",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "818",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Pella",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "819",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Pieria",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "820",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Preveza",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "821",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Rethimni",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "822",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Rodhopi",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "823",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Samos",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "824",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Serrai",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "825",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Thesprotia",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "826",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Thessaloniki",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "827",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Trikala",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "828",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Voiotia",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "829",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Xanthi",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "830",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GR",
    "name": "Zakinthos",
    "timeZone": "Europe/Athens"
  },
  {
    "id": "831",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GL",
    "name": "Nordgronland",
    "timeZone": "America/Danmarkshavn"
  },
  {
    "id": "832",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GL",
    "name": "Ostgronland",
    "timeZone": "America/Scoresbysund"
  },
  {
    "id": "833",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GL",
    "name": "Vestgronland",
    "timeZone": "America/Godthab"
  },
  {
    "id": "834",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Alta Verapaz",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "835",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Baja Verapaz",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "836",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Chimaltenango",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "837",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Chiquimula",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "838",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "El Progreso",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "839",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Escuintla",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "840",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Guatemala",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "841",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Huehuetenango",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "842",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Izabal",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "843",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Jalapa",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "844",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Jutiapa",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "845",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Peten",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "846",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Quetzaltenango",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "847",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Quiche",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "848",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Retalhuleu",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "849",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Sacatepequez",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "850",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "San Marcos",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "851",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Santa Rosa",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "852",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Solola",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "853",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Suchitepequez",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "854",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Totonicapan",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "855",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "GT",
    "name": "Zacapa",
    "timeZone": "America/Guatemala"
  },
  {
    "id": "856",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HT",
    "name": "Artibonite",
    "timeZone": "America/Port-au-Prince"
  },
  {
    "id": "857",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HT",
    "name": "Centre",
    "timeZone": "America/Port-au-Prince"
  },
  {
    "id": "858",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HT",
    "name": "Grand' Anse",
    "timeZone": "America/Port-au-Prince"
  },
  {
    "id": "859",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HT",
    "name": "Nord",
    "timeZone": "America/Port-au-Prince"
  },
  {
    "id": "860",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HT",
    "name": "Nord-Est",
    "timeZone": "America/Port-au-Prince"
  },
  {
    "id": "861",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HT",
    "name": "Nord-Ouest",
    "timeZone": "America/Port-au-Prince"
  },
  {
    "id": "862",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HT",
    "name": "Ouest",
    "timeZone": "America/Port-au-Prince"
  },
  {
    "id": "863",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HT",
    "name": "Sud",
    "timeZone": "America/Port-au-Prince"
  },
  {
    "id": "864",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HT",
    "name": "Sud-Est",
    "timeZone": "America/Port-au-Prince"
  },
  {
    "id": "865",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Atlantida",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "866",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Choluteca",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "867",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Colon",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "868",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Comayagua",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "869",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Copan",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "870",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Cortes",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "871",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "El Paraiso",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "872",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Francisco Morazan",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "873",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Gracias a Dios",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "874",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Intibuca",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "875",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Islas de la Bahia",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "876",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "La Paz",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "877",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Lempira",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "878",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Ocotepeque",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "879",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Olancho",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "880",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Santa Barbara",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "881",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Valle",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "882",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HN",
    "name": "Yoro",
    "timeZone": "America/Tegucigalpa"
  },
  {
    "id": "883",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HK",
    "name": "Hong Kong",
    "timeZone": "Asia/Hong_Kong"
  },
  {
    "id": "884",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Bacs-Kiskun",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "885",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Baranya",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "886",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Bekes",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "887",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Bekescsaba",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "888",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Borsod-Abauj-Zempl",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "889",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Budapest",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "890",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Csongrad",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "891",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Debrecen",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "892",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Dunaujvaros",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "893",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Eger",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "894",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Fejer",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "895",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Gyor",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "896",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Gyor-Moson-Sopron",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "897",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Hajdu-Bihar",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "898",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Heves",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "899",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Hodmezovasarhely",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "900",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Jasz-Nagykun-Szoln",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "901",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Kaposvar",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "902",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Kecskemet",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "903",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Komarom-Esztergom",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "904",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Miskolc",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "905",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Nagykanizsa",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "906",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Nograd",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "907",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Nyiregyhaza",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "908",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Pecs",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "909",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Pest",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "910",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Somogy",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "911",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Sopron",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "912",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Szabolcs-Szatmar-B",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "913",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Szeged",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "914",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Szekesfehervar",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "915",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Szolnok",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "916",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Szombathely",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "917",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Tatabanya",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "918",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Tolna",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "919",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Vas",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "920",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Veszprem",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "921",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Zala",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "922",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "HU",
    "name": "Zalaegerszeg",
    "timeZone": "Europe/Budapest"
  },
  {
    "id": "923",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Akranes",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "924",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Akureyri",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "925",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Arnessysla",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "926",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Austur-Bardastrand",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "927",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Austur-Hunavatnssy",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "928",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Austur-Skaftafells",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "929",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Borgarfjardarsysla",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "930",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Dalasysla",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "931",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Eyjafjardarsysla",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "932",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Gullbringusysla",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "933",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Hafnarfjordur",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "934",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Husavik",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "935",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Isafjordur",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "936",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Keflavik",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "937",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Kjosarsysla",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "938",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Kopavogur",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "939",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Myrasysla",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "940",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Neskaupstadur",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "941",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Nordur-Isafjardars",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "942",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Nordur-Mulasysla",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "943",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Nordur-Tingeyjarsy",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "944",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Olafsfjordur",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "945",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Rangarvallasysla",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "946",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Reykjavik",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "947",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Saudarkrokur",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "948",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Seydisfjordur",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "949",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Siglufjordur",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "950",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Skagafjardarsysla",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "951",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Snafellsnes- og Hn",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "952",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Strandasysla",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "953",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Sudur-Mulasysla",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "954",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Sudur-Tingeyjarsys",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "955",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Vestmannaeyjar",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "956",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Vestur-Bardastrand",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "957",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Vestur-Hunavatnssy",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "958",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Vestur-Isafjardars",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "959",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IS",
    "name": "Vestur-Skaftafells",
    "timeZone": "Atlantic/Reykjavik"
  },
  {
    "id": "960",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Andaman and Nicoba",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "961",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Andhra Pradesh",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "962",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Arunachal Pradesh",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "963",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Assam",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "964",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Bihar",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "965",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Chandigarh",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "966",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Dadra and Nagar Ha",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "967",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Daman and Diu",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "968",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Delhi",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "969",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Goa",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "970",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Gujarat",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "971",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Haryana",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "972",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Himachal Pradesh",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "973",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Jammu and Kashmir",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "974",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Karnataka",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "975",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Kerala",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "976",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Lakshadweep",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "977",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Madhya Pradesh",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "978",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Maharashtra",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "979",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Manipur",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "980",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Meghalaya",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "981",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Mizoram",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "982",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Nagaland",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "983",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Orissa",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "984",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Pondicherry",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "985",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Punjab",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "986",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Rajasthan",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "987",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Sikkim",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "988",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Tamil Nadu",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "989",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Tripura",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "990",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "Uttar Pradesh",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "991",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IN",
    "name": "West Bengal",
    "timeZone": "Asia/Kolkata"
  },
  {
    "id": "992",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Aceh",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "993",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Bali",
    "timeZone": "Asia/Makassar"
  },
  {
    "id": "994",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Bengkulu",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "995",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Irian Jaya",
    "timeZone": "Asia/Jayapura"
  },
  {
    "id": "996",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Jakarta Raya",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "997",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Jambi",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "998",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Jawa Barat",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "999",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Jawa Tengah",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "1000",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Jawa Timur",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "1001",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Kalimantan Barat",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "1002",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Kalimantan Selatan",
    "timeZone": "Asia/Makassar"
  },
  {
    "id": "1003",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Kalimantan Tengah",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "1004",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Kalimantan Timur",
    "timeZone": "Asia/Makassar"
  },
  {
    "id": "1005",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Lampung",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "1006",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Maluku",
    "timeZone": "Asia/Jayapura"
  },
  {
    "id": "1007",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Nusa Tenggara Bara",
    "timeZone": "Asia/Makassar"
  },
  {
    "id": "1008",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Nusa Tenggara Timu",
    "timeZone": "Asia/Makassar"
  },
  {
    "id": "1009",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Riau",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "1010",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Sulawesi Selatan",
    "timeZone": "Asia/Makassar"
  },
  {
    "id": "1011",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Sulawesi Tengah",
    "timeZone": "Asia/Makassar"
  },
  {
    "id": "1012",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Sulawesi Tenggara",
    "timeZone": "Asia/Makassar"
  },
  {
    "id": "1013",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Sulawesi Utara",
    "timeZone": "Asia/Makassar"
  },
  {
    "id": "1014",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Sumatera Barat",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "1015",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Sumatera Selatan",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "1016",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Sumatera Utara",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "1017",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Timor Timur",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "1018",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ID",
    "name": "Yogyakarta",
    "timeZone": "Asia/Jakarta"
  },
  {
    "id": "1019",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Azarbayjan-e Bakht",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1020",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Azarbayjan-e Khava",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1021",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Bakhtaran",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1022",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Bushehr",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1023",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Chahar Mahall va B",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1024",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Esfahan",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1025",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Fars",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1026",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Gilan",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1027",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Hamadan",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1028",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Hormozgan",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1029",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Ilam",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1030",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Kerman",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1031",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Khorasan",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1032",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Khuzestan",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1033",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Kohkiluyeh va Buye",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1034",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Kordestan",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1035",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Lorestan",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1036",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Markazi",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1037",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Mazandaran",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1038",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Semnan",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1039",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Sistan va Baluches",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1040",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Tehran",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1041",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Yazd",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1042",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IR",
    "name": "Zanjan",
    "timeZone": "Asia/Tehran"
  },
  {
    "id": "1043",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Al Anbar",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1044",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Al Basrah",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1045",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Al Muthanna",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1046",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Al Qadisiyah",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1047",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "An Najaf",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1048",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Arbil",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1049",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "As Sulaymaniyah",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1050",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "At Ta'mim",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1051",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Babil",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1052",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Baghdad",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1053",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Dahuk",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1054",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Dhi Qar",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1055",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Diyala",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1056",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Karbala",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1057",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Maysan",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1058",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Ninawa",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1059",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Salah ad Din",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1060",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IQ",
    "name": "Wasit",
    "timeZone": "Asia/Baghdad"
  },
  {
    "id": "1061",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Carlow",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1062",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Cavan",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1063",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Clare",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1064",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Cork",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1065",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Donegal",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1066",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Dublin",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1067",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Galway",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1068",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Kerry",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1069",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Kildare",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1070",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Kilkenny",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1071",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Laois",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1072",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Leitrim",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1073",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Limerick",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1074",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Longford",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1075",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Louth",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1076",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Mayo",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1077",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Meath",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1078",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Monaghan",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1079",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Offaly",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1080",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Roscommon",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1081",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Sligo",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1082",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Tipperary",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1083",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Waterford",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1084",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Westmeath",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1085",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Wexford",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1086",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IE",
    "name": "Wicklow",
    "timeZone": "Europe/Dublin"
  },
  {
    "id": "1087",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IL",
    "name": "HaDarom",
    "timeZone": "Asia/Jerusalem"
  },
  {
    "id": "1088",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IL",
    "name": "HaMerkaz",
    "timeZone": "Asia/Jerusalem"
  },
  {
    "id": "1089",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IL",
    "name": "HaZafon",
    "timeZone": "Asia/Jerusalem"
  },
  {
    "id": "1090",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IL",
    "name": "Hefa",
    "timeZone": "Asia/Jerusalem"
  },
  {
    "id": "1091",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IL",
    "name": "Tel Aviv",
    "timeZone": "Asia/Jerusalem"
  },
  {
    "id": "1092",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IL",
    "name": "Yerushalayim",
    "timeZone": "Asia/Jerusalem"
  },
  {
    "id": "1093",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Abruzzi",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1094",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Basilicata",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1095",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Calabria",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1096",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Campania",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1097",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Emilia-Romagna",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1098",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Friuli-Venezia Giu",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1099",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Lazio",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1100",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Liguria",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1101",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Lombardia",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1102",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Marche",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1103",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Molise",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1104",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Piemonte",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1105",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Puglia",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1106",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Sardegna",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1107",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Sicilia",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1108",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Toscana",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1109",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Trentino-Alto Adig",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1110",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Umbria",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1111",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Valle d'Aosta",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1112",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "IT",
    "name": "Veneto",
    "timeZone": "Europe/Rome"
  },
  {
    "id": "1113",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Clarendon",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1114",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Hanover",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1115",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Kingston",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1116",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Manchester",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1117",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Portland",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1118",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Saint Andrew",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1119",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Saint Ann",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1120",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Saint Catherine",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1121",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Saint Elizabeth",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1122",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Saint James",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1123",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Saint Mary",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1124",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Saint Thomas",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1125",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Trelawny",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1126",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JM",
    "name": "Westmoreland",
    "timeZone": "America/Jamaica"
  },
  {
    "id": "1127",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Aichi",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1128",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Akita",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1129",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Aomori",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1130",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Chiba",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1131",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Ehime",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1132",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Fukui",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1133",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Fukuoka",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1134",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Fukushima",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1135",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Gifu",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1136",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Gumma",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1137",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Hiroshima",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1138",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Hokkaido",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1139",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Hyogo",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1140",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Ibaraki",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1141",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Ishikawa",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1142",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Iwate",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1143",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Kagawa",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1144",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Kagoshima",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1145",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Kanagawa",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1146",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Kochi",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1147",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Kumamoto",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1148",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Kyoto",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1149",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Mie",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1150",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Miyagi",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1151",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Miyazaki",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1152",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Nagano",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1153",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Nagasaki",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1154",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Nara",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1155",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Niigata",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1156",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Oita",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1157",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Okayama",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1158",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Okinawa",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1159",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Osaka",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1160",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Saga",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1161",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Saitama",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1162",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Shiga",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1163",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Shimane",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1164",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Shizuoka",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1165",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Tochigi",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1166",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Tokushima",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1167",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Tokyo",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1168",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Tottori",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1169",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Toyama",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1170",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Wakayama",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1171",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Yamagata",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1172",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Yamaguchi",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1173",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JP",
    "name": "Yamanashi",
    "timeZone": "Asia/Tokyo"
  },
  {
    "id": "1174",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JO",
    "name": "Al Balqa",
    "timeZone": "Asia/Amman"
  },
  {
    "id": "1175",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JO",
    "name": "Al Karak",
    "timeZone": "Asia/Amman"
  },
  {
    "id": "1176",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JO",
    "name": "Al Mafraq",
    "timeZone": "Asia/Amman"
  },
  {
    "id": "1177",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JO",
    "name": "Amman",
    "timeZone": "Asia/Amman"
  },
  {
    "id": "1178",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JO",
    "name": "At Tafilah",
    "timeZone": "Asia/Amman"
  },
  {
    "id": "1179",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JO",
    "name": "Az Zarqa",
    "timeZone": "Asia/Amman"
  },
  {
    "id": "1180",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JO",
    "name": "Irbid",
    "timeZone": "Asia/Amman"
  },
  {
    "id": "1181",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "JO",
    "name": "Ma an",
    "timeZone": "Asia/Amman"
  },
  {
    "id": "1182",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KE",
    "name": "Central",
    "timeZone": "Africa/Nairobi"
  },
  {
    "id": "1183",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KE",
    "name": "Coast",
    "timeZone": "Africa/Nairobi"
  },
  {
    "id": "1184",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KE",
    "name": "Eastern",
    "timeZone": "Africa/Nairobi"
  },
  {
    "id": "1185",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KE",
    "name": "Nairobi Area",
    "timeZone": "Africa/Nairobi"
  },
  {
    "id": "1186",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KE",
    "name": "North-Eastern",
    "timeZone": "Africa/Nairobi"
  },
  {
    "id": "1187",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KE",
    "name": "Nyanza",
    "timeZone": "Africa/Nairobi"
  },
  {
    "id": "1188",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KE",
    "name": "Rift Valley",
    "timeZone": "Africa/Nairobi"
  },
  {
    "id": "1189",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KE",
    "name": "Western",
    "timeZone": "Africa/Nairobi"
  },
  {
    "id": "1190",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Cheju-do",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1191",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Cholla-bukto",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1192",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Cholla-namdo",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1193",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Ch'ungch'ong-bukto",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1194",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Ch'ungch'ong-namdo",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1195",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Inch'on-jikhalsi",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1196",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Kangwon-do",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1197",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Kwangju-jikhalsi",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1198",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Kyonggi-do",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1199",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Kyongsang-bukto",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1200",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Kyongsang-namdo",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1201",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Pusan-jikhalsi",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1202",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Soul-t'ukpyolsi",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1203",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Taegu-jikhalsi",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1204",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KP",
    "name": "Taejon-jikhalsi",
    "timeZone": "Asia/Pyongyang"
  },
  {
    "id": "1205",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KR",
    "name": "Chagang-do",
    "timeZone": "Asia/Seoul"
  },
  {
    "id": "1206",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KR",
    "name": "Hamgyong-bukto",
    "timeZone": "Asia/Seoul"
  },
  {
    "id": "1207",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KR",
    "name": "Hamgyong-namdo",
    "timeZone": "Asia/Seoul"
  },
  {
    "id": "1208",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KR",
    "name": "Hwanghae-bukto",
    "timeZone": "Asia/Seoul"
  },
  {
    "id": "1209",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KR",
    "name": "Hwanghae-namdo",
    "timeZone": "Asia/Seoul"
  },
  {
    "id": "1210",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KR",
    "name": "Kaesong-si",
    "timeZone": "Asia/Seoul"
  },
  {
    "id": "1211",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KR",
    "name": "Kangwon-do",
    "timeZone": "Asia/Seoul"
  },
  {
    "id": "1212",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KR",
    "name": "Namp'o-si",
    "timeZone": "Asia/Seoul"
  },
  {
    "id": "1213",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KR",
    "name": "P'yongan-bukto",
    "timeZone": "Asia/Seoul"
  },
  {
    "id": "1214",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KR",
    "name": "P'yongan-namdo",
    "timeZone": "Asia/Seoul"
  },
  {
    "id": "1215",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KR",
    "name": "P'yongyang-si",
    "timeZone": "Asia/Seoul"
  },
  {
    "id": "1216",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KR",
    "name": "Yanggang-do",
    "timeZone": "Asia/Seoul"
  },
  {
    "id": "1217",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KW",
    "name": "Al Ahmadi",
    "timeZone": "Asia/Kuwait"
  },
  {
    "id": "1218",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KW",
    "name": "Al Kuwayt",
    "timeZone": "Asia/Kuwait"
  },
  {
    "id": "1219",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "KW",
    "name": "Hawalli",
    "timeZone": "Asia/Kuwait"
  },
  {
    "id": "1220",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LB",
    "name": "Al Biqa",
    "timeZone": "Asia/Beirut"
  },
  {
    "id": "1221",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LB",
    "name": "Al Janub",
    "timeZone": "Asia/Beirut"
  },
  {
    "id": "1222",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LB",
    "name": "Ash Shamal",
    "timeZone": "Asia/Beirut"
  },
  {
    "id": "1223",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LB",
    "name": "Bayrut",
    "timeZone": "Asia/Beirut"
  },
  {
    "id": "1224",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LB",
    "name": "Jabal Lubnan",
    "timeZone": "Asia/Beirut"
  },
  {
    "id": "1225",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LU",
    "name": "Diekirch",
    "timeZone": "Europe/Luxembourg"
  },
  {
    "id": "1226",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LU",
    "name": "Grevenmacher",
    "timeZone": "Europe/Luxembourg"
  },
  {
    "id": "1227",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LU",
    "name": "Luxembourg",
    "timeZone": "Europe/Luxembourg"
  },
  {
    "id": "1228",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Johor",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1229",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Kedah",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1230",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Kelantan",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1231",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Labuan",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1232",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Melaka",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1233",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Negeri Sembilan",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1234",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Pahang",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1235",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Perak",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1236",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Perlis",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1237",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Pulau Pinang",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1238",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Sabah",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1239",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Sarawak",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1240",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Selangor",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1241",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Terengganu",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1242",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MY",
    "name": "Wilayah Persekutua",
    "timeZone": "Asia/Kuala_Lumpur"
  },
  {
    "id": "1243",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Aguascalientes",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1244",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Baja California",
    "timeZone": "America/Tijuana"
  },
  {
    "id": "1245",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Baja California Su",
    "timeZone": "America/Mazatlan"
  },
  {
    "id": "1246",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Campeche",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1247",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Chiapas",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1248",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Chihuahua",
    "timeZone": "America/Chihuahua"
  },
  {
    "id": "1249",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Coahuila de Zarago",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1250",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Colima",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1251",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Distrito Federal",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1252",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Durango",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1253",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Guanajuato",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1254",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Guerrero",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1255",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Hidalgo",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1256",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Jalisco",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1257",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Mexico",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1258",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Michoacan de Ocamp",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1259",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Morelos",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1260",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Nayarit",
    "timeZone": "America/Chihuahua"
  },
  {
    "id": "1261",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Nuevo Leon",
    "timeZone": "America/Monterrey"
  },
  {
    "id": "1262",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Oaxaca",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1263",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Puebla",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1264",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Queretaro de Artea",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1265",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Quintana Roo",
    "timeZone": "America/Cancun"
  },
  {
    "id": "1266",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "San Luis Potosi",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1267",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Sinaloa",
    "timeZone": "America/Mazatlan"
  },
  {
    "id": "1268",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Sonora",
    "timeZone": "America/Hermosillo"
  },
  {
    "id": "1269",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Tabasco",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1270",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Tamaulipas",
    "timeZone": "America/Matamoros"
  },
  {
    "id": "1271",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Tlaxcala",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1272",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Veracruz-Llave",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1273",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Yucatan",
    "timeZone": "America/Merida"
  },
  {
    "id": "1274",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MX",
    "name": "Zacatecas",
    "timeZone": "America/Mexico_City"
  },
  {
    "id": "1275",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MC",
    "name": "La Condamine",
    "timeZone": "Europe/Monaco"
  },
  {
    "id": "1276",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MC",
    "name": "Monaco",
    "timeZone": "Europe/Monaco"
  },
  {
    "id": "1277",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MC",
    "name": "Monte-Carlo",
    "timeZone": "Europe/Monaco"
  },
  {
    "id": "1278",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Arhangay",
    "timeZone": "Asia/Hovd"
  },
  {
    "id": "1279",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Bayanhongor",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1280",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Bayan-Olgiy",
    "timeZone": "Asia/Hovd"
  },
  {
    "id": "1281",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Bulgan",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1282",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Darhan",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1283",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Dornod",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1284",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Dornogovi",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1285",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Dundgovi",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1286",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Dzavhan",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1287",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Erdenet",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1288",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Govi-Altay",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1289",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Hentiy",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1290",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Hovd",
    "timeZone": "Asia/Hovd"
  },
  {
    "id": "1291",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Hovsgol",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1292",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Omnogovi",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1293",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Ovorhangay",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1294",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Selenge",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1295",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Suhbaatar",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1296",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Tov",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1297",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Ulaanbaatar",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1298",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MN",
    "name": "Uvs",
    "timeZone": "Asia/Ulaanbaatar"
  },
  {
    "id": "1299",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Agadir",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1300",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Al Hoceima",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1301",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Azilal",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1302",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Ben Slimane",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1303",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Beni Mellal",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1304",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Boulemane",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1305",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Casablanca",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1306",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Chaouen",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1307",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "El Jadida",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1308",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "El Kelaa des Srarh",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1309",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Er Rachidia",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1310",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Essaouira",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1311",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Fes",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1312",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Figuig",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1313",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Guelmim",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1314",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Ifrane",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1315",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Kenitra",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1316",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Khemisset",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1317",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Khenifra",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1318",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Khouribga",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1319",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Laayoune",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1320",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Larache",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1321",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Marrakech",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1322",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Meknes",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1323",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Nador",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1324",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Ouarzazate",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1325",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Oujda",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1326",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Rabat-Sale",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1327",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Safi",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1328",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Settat",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1329",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Sidi Kacem",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1330",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Tanger",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1331",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Tan-Tan",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1332",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Taounate",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1333",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Taroudannt",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1334",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Tata",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1335",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Taza",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1336",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Tetouan",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1337",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MA",
    "name": "Tiznit",
    "timeZone": "Africa/Casablanca"
  },
  {
    "id": "1338",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MZ",
    "name": "Cabo Delgado",
    "timeZone": "Africa/Maputo"
  },
  {
    "id": "1339",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MZ",
    "name": "Gaza",
    "timeZone": "Africa/Maputo"
  },
  {
    "id": "1340",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MZ",
    "name": "Inhambane",
    "timeZone": "Africa/Maputo"
  },
  {
    "id": "1341",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MZ",
    "name": "Manica",
    "timeZone": "Africa/Maputo"
  },
  {
    "id": "1342",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MZ",
    "name": "Maputo",
    "timeZone": "Africa/Maputo"
  },
  {
    "id": "1343",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MZ",
    "name": "Nampula",
    "timeZone": "Africa/Maputo"
  },
  {
    "id": "1344",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MZ",
    "name": "Niassa",
    "timeZone": "Africa/Maputo"
  },
  {
    "id": "1345",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MZ",
    "name": "Sofala",
    "timeZone": "Africa/Maputo"
  },
  {
    "id": "1346",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MZ",
    "name": "Tete",
    "timeZone": "Africa/Maputo"
  },
  {
    "id": "1347",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MZ",
    "name": "Zambezia",
    "timeZone": "Africa/Maputo"
  },
  {
    "id": "1348",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Chin State",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1349",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Irrawaddy",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1350",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Kachin State",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1351",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Karan State",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1352",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Kayah State",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1353",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Magwe",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1354",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Mandalay",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1355",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Mon State",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1356",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Pegu",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1357",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Rakhine State",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1358",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Rangoon",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1359",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Sagaing",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1360",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Shan State",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1361",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "MM",
    "name": "Tenasserim",
    "timeZone": "Asia/Rangoon"
  },
  {
    "id": "1362",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Bethanien",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1363",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Boesmanland",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1364",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Caprivi Oos",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1365",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Damaraland",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1366",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Gobabis",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1367",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Grootfontein",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1368",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Hereroland Oos",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1369",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Hereroland Wes",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1370",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Kaokoland",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1371",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Karasburg",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1372",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Karibib",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1373",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Kavango",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1374",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Keetmanshoop",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1375",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Luderitz",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1376",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Maltahohe",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1377",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Mariental",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1378",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Namaland",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1379",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Okahandja",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1380",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Omaruru",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1381",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Otjiwarongo",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1382",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Outjo",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1383",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Owambo",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1384",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Rehoboth",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1385",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Swakopmund",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1386",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Tsumeb",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1387",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NA",
    "name": "Windhoek",
    "timeZone": "Africa/Windhoek"
  },
  {
    "id": "1388",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Aiwo",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1389",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Anabar",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1390",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Anetan",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1391",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Anibare",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1392",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Baiti",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1393",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Boe",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1394",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Buada",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1395",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Denigomodu",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1396",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Ewa",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1397",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Ijuw",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1398",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Meneng",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1399",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Nibok",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1400",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Uaboe",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1401",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NR",
    "name": "Yaren",
    "timeZone": "Pacific/Nauru"
  },
  {
    "id": "1402",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Bagmati",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1403",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Bheri",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1404",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Dhawalagiri",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1405",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Gandaki",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1406",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Janakpur",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1407",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Karnali",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1408",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Kosi",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1409",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Lumbini",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1410",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Mahakali",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1411",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Mechi",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1412",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Narayani",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1413",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Rapti",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1414",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Sagarmatha",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1415",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NP",
    "name": "Seti",
    "timeZone": "Asia/Kathmandu"
  },
  {
    "id": "1416",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Drenthe",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1417",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Dronten",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1418",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Friesland",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1419",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Gelderland",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1420",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Groningen",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1421",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Lelystad",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1422",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Limburg",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1423",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Noord-Brabant",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1424",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Noord-Holland",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1425",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Overijssel",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1426",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Utrecht",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1427",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Zeeland",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1428",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Zuidelijke IJsselm",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1429",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NL",
    "name": "Zuid-Holland",
    "timeZone": "Europe/Amsterdam"
  },
  {
    "id": "1430",
    "stateCode": "AUCK",
    "capitalCityName": "Auckland",
    "countryCode": "NZ",
    "name": "Auckland",
    "timeZone": "Pacific/Auckland"
  },
  {
    "id": "1431",
    "stateCode": "WELL",
    "capitalCityName": "Wellington",
    "countryCode": "NZ",
    "name": "Wellington",
    "timeZone": "Pacific/Auckland"
  },
  {
    "id": "1432",
    "stateCode": null,
    "capitalCityName": "Christchurch",
    "countryCode": "NZ",
    "name": "Christchurch",
    "timeZone": "Pacific/Auckland"
  },
  {
    "id": "1433",
    "stateCode": null,
    "capitalCityName": "Queenstown",
    "countryCode": "NZ",
    "name": "Queenstown",
    "timeZone": "Pacific/Auckland"
  },
  {
    "id": "1434",
    "stateCode": null,
    "capitalCityName": "Dunedin",
    "countryCode": "NZ",
    "name": "Dunedin",
    "timeZone": "Pacific/Auckland"
  },
  {
    "id": "1535",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Boaco",
    "timeZone": "America/Managua"
  },
  {
    "id": "1536",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Carazo",
    "timeZone": "America/Managua"
  },
  {
    "id": "1537",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Chinandega",
    "timeZone": "America/Managua"
  },
  {
    "id": "1538",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Chontales",
    "timeZone": "America/Managua"
  },
  {
    "id": "1539",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Esteli",
    "timeZone": "America/Managua"
  },
  {
    "id": "1540",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Granada",
    "timeZone": "America/Managua"
  },
  {
    "id": "1541",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Jinotega",
    "timeZone": "America/Managua"
  },
  {
    "id": "1542",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Leon",
    "timeZone": "America/Managua"
  },
  {
    "id": "1543",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Madriz",
    "timeZone": "America/Managua"
  },
  {
    "id": "1544",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Managua",
    "timeZone": "America/Managua"
  },
  {
    "id": "1545",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Masaya",
    "timeZone": "America/Managua"
  },
  {
    "id": "1546",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Matagalpa",
    "timeZone": "America/Managua"
  },
  {
    "id": "1547",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Nueva Segovia",
    "timeZone": "America/Managua"
  },
  {
    "id": "1548",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Rio San Juan",
    "timeZone": "America/Managua"
  },
  {
    "id": "1549",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Rivas",
    "timeZone": "America/Managua"
  },
  {
    "id": "1550",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NI",
    "name": "Zelaya",
    "timeZone": "America/Managua"
  },
  {
    "id": "1551",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Abia",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1552",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Abuja Capital Terr",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1553",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Adamawa",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1554",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Akwa Ibom",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1555",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Anambra",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1556",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Bauchi",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1557",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Benue",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1558",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Borno",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1559",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Cross River",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1560",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Delta",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1561",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Edo",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1562",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Enugu",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1563",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Imo",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1564",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Jigawa",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1565",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Kaduna",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1566",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Kano",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1567",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Katsina",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1568",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Kebbi",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1569",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Kogi",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1570",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Kwara",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1571",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Lagos",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1572",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Niger",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1573",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Ogun",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1574",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Ondo",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1575",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Osun",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1576",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Oyo",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1577",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Plateau",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1578",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Rivers",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1579",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Sokoto",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1580",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Taraba",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1581",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NG",
    "name": "Yobe",
    "timeZone": "Africa/Lagos"
  },
  {
    "id": "1582",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Akershus",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1583",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Aust-Agder",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1584",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Buskerud",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1585",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Finnmark",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1586",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Hedmark",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1587",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Hordaland",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1588",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "More og Romsdal",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1589",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Nordland",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1590",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Nord-Trondelag",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1591",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Oppland",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1592",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Oslo",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1593",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Ostfold",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1594",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Rogaland",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1595",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Sogn og Fjordane",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1596",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Sor-Trondelag",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1597",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Telemark",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1598",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Troms",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1599",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Vest-Agder",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1600",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "NO",
    "name": "Vestfold",
    "timeZone": "Europe/Oslo"
  },
  {
    "id": "1601",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PK",
    "name": "Azad Kashmir",
    "timeZone": "Asia/Karachi"
  },
  {
    "id": "1602",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PK",
    "name": "Balochistan",
    "timeZone": "Asia/Karachi"
  },
  {
    "id": "1603",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PK",
    "name": "Federally Administ",
    "timeZone": "Asia/Karachi"
  },
  {
    "id": "1604",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PK",
    "name": "Islamabad",
    "timeZone": "Asia/Karachi"
  },
  {
    "id": "1605",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PK",
    "name": "Northern Areas",
    "timeZone": "Asia/Karachi"
  },
  {
    "id": "1606",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PK",
    "name": "North-West Frontie",
    "timeZone": "Asia/Karachi"
  },
  {
    "id": "1607",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PK",
    "name": "Punjab",
    "timeZone": "Asia/Karachi"
  },
  {
    "id": "1608",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PK",
    "name": "Sindh",
    "timeZone": "Asia/Karachi"
  },
  {
    "id": "1609",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PA",
    "name": "Bocas del Toro",
    "timeZone": "America/Panama"
  },
  {
    "id": "1610",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PA",
    "name": "Chiriqui",
    "timeZone": "America/Panama"
  },
  {
    "id": "1611",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PA",
    "name": "Cocle",
    "timeZone": "America/Panama"
  },
  {
    "id": "1612",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PA",
    "name": "Colon",
    "timeZone": "America/Panama"
  },
  {
    "id": "1613",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PA",
    "name": "Darien",
    "timeZone": "America/Panama"
  },
  {
    "id": "1614",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PA",
    "name": "Herrera",
    "timeZone": "America/Panama"
  },
  {
    "id": "1615",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PA",
    "name": "Los Santos",
    "timeZone": "America/Panama"
  },
  {
    "id": "1616",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PA",
    "name": "Panama",
    "timeZone": "America/Panama"
  },
  {
    "id": "1617",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PA",
    "name": "San Blas",
    "timeZone": "America/Panama"
  },
  {
    "id": "1618",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PA",
    "name": "Veraguas",
    "timeZone": "America/Panama"
  },
  {
    "id": "1619",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Central",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1620",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Chimbu",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1621",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "East New Britain",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1622",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "East Sepik",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1623",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Eastern Highlands",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1624",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Enga",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1625",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Gulf",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1626",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Madang",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1627",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Manus",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1628",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Milne Bay",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1629",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Morobe",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1630",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "National Capital",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1631",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "New Ireland",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1632",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "North Solomons",
    "timeZone": "Pacific/Bougainville"
  },
  {
    "id": "1633",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Northern",
    "timeZone": "Pacific/Bougainville"
  },
  {
    "id": "1634",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Sandaun",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1635",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Southern Highlands",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1636",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "West New Britain",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1637",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Western",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1638",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PG",
    "name": "Western Highlands",
    "timeZone": "Pacific/Port_Moresby"
  },
  {
    "id": "1639",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Alto Paraguay",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1640",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Alto Parana",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1641",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Amambay",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1642",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Boqueron",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1643",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Caaguazu",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1644",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Caazapa",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1645",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Canindeyu",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1646",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Central",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1647",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Chaco",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1648",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Concepcion",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1649",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Cordillera",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1650",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Guaira",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1651",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Itapua",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1652",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Misiones",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1653",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Neembucu",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1654",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Nueva Asuncion",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1655",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Paraguari",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1656",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "Presidente Hayes",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1657",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PY",
    "name": "San Pedro",
    "timeZone": "America/Asuncion"
  },
  {
    "id": "1658",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Amazonas",
    "timeZone": "America/Lima"
  },
  {
    "id": "1659",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Ancash",
    "timeZone": "America/Lima"
  },
  {
    "id": "1660",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Apurimac",
    "timeZone": "America/Lima"
  },
  {
    "id": "1661",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Arequipa",
    "timeZone": "America/Lima"
  },
  {
    "id": "1662",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Ayacucho",
    "timeZone": "America/Lima"
  },
  {
    "id": "1663",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Cajamarca",
    "timeZone": "America/Lima"
  },
  {
    "id": "1664",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Callao",
    "timeZone": "America/Lima"
  },
  {
    "id": "1665",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Cusco",
    "timeZone": "America/Lima"
  },
  {
    "id": "1666",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Huancavelica",
    "timeZone": "America/Lima"
  },
  {
    "id": "1667",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Huanuco",
    "timeZone": "America/Lima"
  },
  {
    "id": "1668",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Ica",
    "timeZone": "America/Lima"
  },
  {
    "id": "1669",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Junin",
    "timeZone": "America/Lima"
  },
  {
    "id": "1670",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "La Libertad",
    "timeZone": "America/Lima"
  },
  {
    "id": "1671",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Lambayeque",
    "timeZone": "America/Lima"
  },
  {
    "id": "1672",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Lima",
    "timeZone": "America/Lima"
  },
  {
    "id": "1673",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Loreto",
    "timeZone": "America/Lima"
  },
  {
    "id": "1674",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Madre de Dios",
    "timeZone": "America/Lima"
  },
  {
    "id": "1675",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Moquegua",
    "timeZone": "America/Lima"
  },
  {
    "id": "1676",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Pasco",
    "timeZone": "America/Lima"
  },
  {
    "id": "1677",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Piura",
    "timeZone": "America/Lima"
  },
  {
    "id": "1678",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Puno",
    "timeZone": "America/Lima"
  },
  {
    "id": "1679",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "San Martin",
    "timeZone": "America/Lima"
  },
  {
    "id": "1680",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Tacna",
    "timeZone": "America/Lima"
  },
  {
    "id": "1681",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Tumbes",
    "timeZone": "America/Lima"
  },
  {
    "id": "1682",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PE",
    "name": "Ucayali",
    "timeZone": "America/Lima"
  },
  {
    "id": "1683",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Abra",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1684",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Agusan del Norte",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1685",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Agusan del Sur",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1686",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Aklan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1687",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Albay",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1688",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Angeles",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1689",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Antique",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1690",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Aurora",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1691",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Bacolod",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1692",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Bago",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1693",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Baguio",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1694",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Bais",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1695",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Basilan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1696",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Basilan City",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1697",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Bataan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1698",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Batanes",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1699",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Batangas",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1700",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Batangas City",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1701",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Benguet",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1702",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Bohol",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1703",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Bukidnon",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1704",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Bulacan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1705",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Butuan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1706",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Cabanatuan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1707",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Cadiz",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1708",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Cagayan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1709",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Cagayan de Oro",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1710",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Calbayog",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1711",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Caloocan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1712",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Camarines Norte",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1713",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Camarines Sur",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1714",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Camiguin",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1715",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Canlaon",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1716",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Capiz",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1717",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Catanduanes",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1718",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Cavite",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1719",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Cavite City",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1720",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Cebu",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1721",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Cebu City",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1722",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Cotabato",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1723",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Dagupan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1724",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Danao",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1725",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Dapitan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1726",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Davao",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1727",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Davao City",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1728",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Davao del Sur",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1729",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Davao Oriental",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1730",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Dipolog",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1731",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Dumaguete",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1732",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Eastern Samar",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1733",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "General Santos",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1734",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Gingoog",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1735",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Ifugao",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1736",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Iligan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1737",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Ilocos Norte",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1738",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Ilocos Sur",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1739",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Iloilo",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1740",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Iloilo City",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1741",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Iriga",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1742",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Isabela",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1743",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Kalinga-Apayao",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1744",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "La Carlota",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1745",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "La Union",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1746",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Laguna",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1747",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Lanao del Norte",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1748",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Lanao del Sur",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1749",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Laoag",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1750",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Lapu-Lapu",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1751",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Legaspi",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1752",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Leyte",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1753",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Lipa",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1754",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Lucena",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1755",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Maguindanao",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1756",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Mandaue",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1757",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Manila",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1758",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Marawi",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1759",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Marinduque",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1760",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Masbate",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1761",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Mindoro Occidental",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1762",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Mindoro Oriental",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1763",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Misamis Occidental",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1764",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Misamis Oriental",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1765",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Mountain",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1766",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Naga",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1767",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Negros Occidental",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1768",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Negros Oriental",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1769",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "North Cotabato",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1770",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Northern Samar",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1771",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Nueva Ecija",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1772",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Nueva Vizcaya",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1773",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Olongapo",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1774",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Ormoc",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1775",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Oroquieta",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1776",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Ozamis",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1777",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Pagadian",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1778",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Palawan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1779",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Palayan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1780",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Pampanga",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1781",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Pangasinan",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1782",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Pasay",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1783",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Puerto Princesa",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1784",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Quezon",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1785",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Quezon City",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1786",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Quirino",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1787",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Rizal",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1788",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Romblon",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1789",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Roxas",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1790",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Samar",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1791",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "San Carlos",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1792",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "San Carlos",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1793",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "San Jose",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1794",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "San Pablo",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1795",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Silay",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1796",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Siquijor",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1797",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Sorsogon",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1798",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "South Cotabato",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1799",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Southern Leyte",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1800",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Sultan Kudarat",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1801",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Sulu",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1802",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Surigao",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1803",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Surigao del Norte",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1804",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Surigao del Sur",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1805",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Tacloban",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1806",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Tagaytay",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1807",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Tagbilaran",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1808",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Tangub",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1809",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Tarlac",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1810",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Tawitawi",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1811",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Toledo",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1812",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Trece Martires",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1813",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Zambales",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1814",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Zamboanga",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1815",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Zamboanga del Nort",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1816",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PH",
    "name": "Zamboanga del Sur",
    "timeZone": "Asia/Manila"
  },
  {
    "id": "1817",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Biala Podlaska",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1818",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Bialystok",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1819",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Bielsko",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1820",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Bydgoszcz",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1821",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Chelm",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1822",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Ciechanow",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1823",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Czestochowa",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1824",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Elblag",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1825",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Gdansk",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1826",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Gorzow",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1827",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Jelenia Gora",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1828",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Kalisz",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1829",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Katowice",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1830",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Kielce",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1831",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Konin",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1832",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Koszalin",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1833",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Krakow",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1834",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Krosno",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1835",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Legnica",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1836",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Leszno",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1837",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Lodz",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1838",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Lomza",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1839",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Lublin",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1840",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Nowy Sacz",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1841",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Olsztyn",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1842",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Opole",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1843",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Ostroleka",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1844",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Pila",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1845",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Piotrkow",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1846",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Plock",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1847",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Poznan",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1848",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Przemysl",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1849",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Radom",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1850",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Rzeszow",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1851",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Siedlce",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1852",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Sieradz",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1853",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Skierniewice",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1854",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Slupsk",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1855",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Suwalki",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1856",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Szczecin",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1857",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Tarnobrzeg",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1858",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Tarnow",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1859",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Torun",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1860",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Walbrzych",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1861",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Warszawa",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1862",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Wloclawek",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1863",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Wroclaw",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1864",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Zamosc",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1865",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PL",
    "name": "Zielona Gora",
    "timeZone": "Europe/Warsaw"
  },
  {
    "id": "1866",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Aveiro",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1867",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Azores",
    "timeZone": "Atlantic/Azores"
  },
  {
    "id": "1868",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Beja",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1869",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Braga",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1870",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Braganca",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1871",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Castelo Branco",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1872",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Coimbra",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1873",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Evora",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1874",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Faro",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1875",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Guarda",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1876",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Leiria",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1877",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Lisboa",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1878",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Madeira",
    "timeZone": "Europe/Madeira"
  },
  {
    "id": "1879",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Portalegre",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1880",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Porto",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1881",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Santarem",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1882",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Setubal",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1883",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Viana do Castelo",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1884",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Vila Real",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1885",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "PT",
    "name": "Viseu",
    "timeZone": "Europe/Lisbon"
  },
  {
    "id": "1886",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Alba",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1887",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Arad",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1888",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Arges",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1889",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Bacau",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1890",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Bihor",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1891",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Bistrita-Nasaud",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1892",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Botosani",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1893",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Braila",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1894",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Brasov",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1895",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Bucuresti",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1896",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Buzau",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1897",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Calarasi",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1898",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Caras-Severin",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1899",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Cluj",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1900",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Constanta",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1901",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Covasna",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1902",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Dimbovita",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1903",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Dolj",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1904",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Galati",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1905",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Giurgiu",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1906",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Gorj",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1907",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Harghita",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1908",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Hunedoara",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1909",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Ialomita",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1910",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Iasi",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1911",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Maramures",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1912",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Mehedinti",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1913",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Mures",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1914",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Neamt",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1915",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Olt",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1916",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Prahova",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1917",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Salaj",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1918",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Satu Mare",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1919",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Sibiu",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1920",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Suceava",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1921",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Teleorman",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1922",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Timis",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1923",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Tulcea",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1924",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Vaslui",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1925",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Vilcea",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1926",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RO",
    "name": "Vrancea",
    "timeZone": "Europe/Bucharest"
  },
  {
    "id": "1927",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RW",
    "name": "Butare",
    "timeZone": "Africa/Kigali"
  },
  {
    "id": "1928",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RW",
    "name": "Byumba",
    "timeZone": "Africa/Kigali"
  },
  {
    "id": "1929",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RW",
    "name": "Cyangugu",
    "timeZone": "Africa/Kigali"
  },
  {
    "id": "1930",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RW",
    "name": "Gikongoro",
    "timeZone": "Africa/Kigali"
  },
  {
    "id": "1931",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RW",
    "name": "Gisenyi",
    "timeZone": "Africa/Kigali"
  },
  {
    "id": "1932",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RW",
    "name": "Gitarama",
    "timeZone": "Africa/Kigali"
  },
  {
    "id": "1933",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RW",
    "name": "Kibungo",
    "timeZone": "Africa/Kigali"
  },
  {
    "id": "1934",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RW",
    "name": "Kibuye",
    "timeZone": "Africa/Kigali"
  },
  {
    "id": "1935",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RW",
    "name": "Kigali",
    "timeZone": "Africa/Kigali"
  },
  {
    "id": "1936",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "RW",
    "name": "Ruhengeri",
    "timeZone": "Africa/Kigali"
  },
  {
    "id": "1937",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "WS",
    "name": "A ana",
    "timeZone": "Pacific/Apia"
  },
  {
    "id": "1938",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "WS",
    "name": "Aiga-i-le-Tai",
    "timeZone": "Pacific/Apia"
  },
  {
    "id": "1939",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "WS",
    "name": "Atua",
    "timeZone": "Pacific/Apia"
  },
  {
    "id": "1940",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "WS",
    "name": "Fa asaleleaga",
    "timeZone": "Pacific/Apia"
  },
  {
    "id": "1941",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "WS",
    "name": "Gaga emauga",
    "timeZone": "Pacific/Apia"
  },
  {
    "id": "1942",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "WS",
    "name": "Gagaifomauga",
    "timeZone": "Pacific/Apia"
  },
  {
    "id": "1943",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "WS",
    "name": "Palauli",
    "timeZone": "Pacific/Apia"
  },
  {
    "id": "1944",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "WS",
    "name": "Satupa itea",
    "timeZone": "Pacific/Apia"
  },
  {
    "id": "1945",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "WS",
    "name": "Tuamasaga",
    "timeZone": "Pacific/Apia"
  },
  {
    "id": "1946",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "WS",
    "name": "Vaa-o-Fonoti",
    "timeZone": "Pacific/Apia"
  },
  {
    "id": "1947",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "WS",
    "name": "Vaisigano",
    "timeZone": "Pacific/Apia"
  },
  {
    "id": "1948",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SM",
    "name": "Borgo Maggiore",
    "timeZone": "Europe/San_Marino"
  },
  {
    "id": "1949",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SM",
    "name": "Chiesanuova",
    "timeZone": "Europe/San_Marino"
  },
  {
    "id": "1950",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SM",
    "name": "Domagnano",
    "timeZone": "Europe/San_Marino"
  },
  {
    "id": "1951",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SM",
    "name": "Faetano",
    "timeZone": "Europe/San_Marino"
  },
  {
    "id": "1952",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SM",
    "name": "Fiorentino",
    "timeZone": "Europe/San_Marino"
  },
  {
    "id": "1953",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SM",
    "name": "Monte Giardino",
    "timeZone": "Europe/San_Marino"
  },
  {
    "id": "1954",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SM",
    "name": "San Marino",
    "timeZone": "Europe/San_Marino"
  },
  {
    "id": "1955",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SM",
    "name": "Serravalle",
    "timeZone": "Europe/San_Marino"
  },
  {
    "id": "1956",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Al Bahah",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1957",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Al Hudud ash Shama",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1958",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Al Jawf",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1959",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Al Madinah",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1960",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Al Qasim",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1961",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Al Qurayyat",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1962",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Ar Riyad",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1963",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Ash Sharqiyah",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1964",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Asir",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1965",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Ha'il",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1966",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Jizan",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1967",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Makkah",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1968",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Najran",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1969",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SA",
    "name": "Tabuk",
    "timeZone": "Asia/Riyadh"
  },
  {
    "id": "1970",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SN",
    "name": "Dakar",
    "timeZone": "Africa/Dakar"
  },
  {
    "id": "1971",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SN",
    "name": "Diourbel",
    "timeZone": "Africa/Dakar"
  },
  {
    "id": "1972",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SN",
    "name": "Fatick",
    "timeZone": "Africa/Dakar"
  },
  {
    "id": "1973",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SN",
    "name": "Kaolack",
    "timeZone": "Africa/Dakar"
  },
  {
    "id": "1974",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SN",
    "name": "Kolda",
    "timeZone": "Africa/Dakar"
  },
  {
    "id": "1975",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SN",
    "name": "Louga",
    "timeZone": "Africa/Dakar"
  },
  {
    "id": "1976",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SN",
    "name": "Saint-Louis",
    "timeZone": "Africa/Dakar"
  },
  {
    "id": "1977",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SN",
    "name": "Tambacounda",
    "timeZone": "Africa/Dakar"
  },
  {
    "id": "1978",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SN",
    "name": "Thies",
    "timeZone": "Africa/Dakar"
  },
  {
    "id": "1979",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SN",
    "name": "Ziguinchor",
    "timeZone": "Africa/Dakar"
  },
  {
    "id": "1980",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SL",
    "name": "Eastern",
    "timeZone": "Africa/Freetown"
  },
  {
    "id": "1981",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SL",
    "name": "Northern",
    "timeZone": "Africa/Freetown"
  },
  {
    "id": "1982",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SL",
    "name": "Southern",
    "timeZone": "Africa/Freetown"
  },
  {
    "id": "1983",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SL",
    "name": "Western Area",
    "timeZone": "Africa/Freetown"
  },
  {
    "id": "1984",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SG",
    "name": "Singapore",
    "timeZone": "Asia/Singapore"
  },
  {
    "id": "1985",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SB",
    "name": "Central",
    "timeZone": "Pacific/Guadalcanal"
  },
  {
    "id": "1986",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SB",
    "name": "Guadalcanal",
    "timeZone": "Pacific/Guadalcanal"
  },
  {
    "id": "1987",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SB",
    "name": "Isabel",
    "timeZone": "Pacific/Guadalcanal"
  },
  {
    "id": "1988",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SB",
    "name": "Makira",
    "timeZone": "Pacific/Guadalcanal"
  },
  {
    "id": "1989",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SB",
    "name": "Malaita",
    "timeZone": "Pacific/Guadalcanal"
  },
  {
    "id": "1990",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SB",
    "name": "Temotu",
    "timeZone": "Pacific/Guadalcanal"
  },
  {
    "id": "1991",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SB",
    "name": "Western",
    "timeZone": "Pacific/Guadalcanal"
  },
  {
    "id": "1992",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Bakool",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "1993",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Banaadir",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "1994",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Bari",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "1995",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Bay",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "1996",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Galguduud",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "1997",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Gedo",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "1998",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Hiiraan",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "1999",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Jubbada Dhexe",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "2000",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Jubbada Hoose",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "2001",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Mudug",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "2002",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Nugaal",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "2003",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Sanaag",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "2004",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Shabeellaha Dhexe",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "2005",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Shabeellaha Hoose",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "2006",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Togdheer",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "2007",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SO",
    "name": "Woqooyi Galbeed",
    "timeZone": "Africa/Mogadishu"
  },
  {
    "id": "2008",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZA",
    "name": "The Northern Cape",
    "timeZone": "Africa/Johannesburg"
  },
  {
    "id": "2009",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZA",
    "name": "KwaZulu-Natal",
    "timeZone": "Africa/Johannesburg"
  },
  {
    "id": "2010",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZA",
    "name": "The Free State",
    "timeZone": "Africa/Johannesburg"
  },
  {
    "id": "2011",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZA",
    "name": "Gauteng",
    "timeZone": "Africa/Johannesburg"
  },
  {
    "id": "2012",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Andalucia",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2013",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Aragon",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2014",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Asturias",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2015",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Canarias",
    "timeZone": "Atlantic/Canary"
  },
  {
    "id": "2016",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Cantabria",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2017",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Castilla y Leon",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2018",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Castilla-La Mancha",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2019",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Cataluna",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2020",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Extremadura",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2021",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Galicia",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2022",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Islas Baleares",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2023",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "La Rioja",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2024",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Madrid",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2025",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Murcia",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2026",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Navarra",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2027",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Pais Vasco",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2028",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ES",
    "name": "Valenciana",
    "timeZone": "Europe/Madrid"
  },
  {
    "id": "2029",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Amparai",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2030",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Anuradhapura",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2031",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Badulla",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2032",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Batticaloa",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2033",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Colombo",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2034",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Galle",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2035",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Gampaha",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2036",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Hambantota",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2037",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Jaffna",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2038",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Kalutara",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2039",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Kandy",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2040",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Kegalla",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2041",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Kurunegala",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2042",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Mannar",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2043",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Matale",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2044",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Matara",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2045",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Moneragala",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2046",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Mullaittivu",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2047",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Nuwara Eliya",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2048",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Polonnaruwa",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2049",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Puttalam",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2050",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Ratnapura",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2051",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Trincomalee",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2052",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "LK",
    "name": "Vavuniya",
    "timeZone": "Asia/Colombo"
  },
  {
    "id": "2053",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SZ",
    "name": "Hhohho",
    "timeZone": "Africa/Mbabane"
  },
  {
    "id": "2054",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SZ",
    "name": "Lubombo",
    "timeZone": "Africa/Mbabane"
  },
  {
    "id": "2055",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SZ",
    "name": "Manzini",
    "timeZone": "Africa/Mbabane"
  },
  {
    "id": "2056",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SZ",
    "name": "Praslin",
    "timeZone": "Africa/Mbabane"
  },
  {
    "id": "2057",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SZ",
    "name": "Shiselweni",
    "timeZone": "Africa/Mbabane"
  },
  {
    "id": "2058",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Alvsborg",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2059",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Blekinge",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2060",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Gavleborg",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2061",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Goteborg",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2062",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Gotland",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2063",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Halland",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2064",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Jamtland",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2065",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Jonkoping",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2066",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Kalmar",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2067",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Kopparberg",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2068",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Kristianstad",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2069",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Kronoberg",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2070",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Malmo",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2071",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Norrbotten",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2072",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Orebro",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2073",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Ostergotland",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2074",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Skaraborg",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2075",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Sodermanland",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2076",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Stockholm",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2077",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Uppsala",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2078",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Varmland",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2079",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Vasterbotten",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2080",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Vasternorrland",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2081",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "SE",
    "name": "Vastmanland",
    "timeZone": "Europe/Stockholm"
  },
  {
    "id": "2082",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Aargau",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2083",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Ausser-Rhoden",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2084",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Basel-Landschaft",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2085",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Basel-Stadt",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2086",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Bern",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2087",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Fribourg",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2088",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Geneve",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2089",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Glarus",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2090",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Graubunden",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2091",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Inner-Rhoden",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2092",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Jura",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2093",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Luzern",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2094",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Neuchatel",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2095",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Nidwalden",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2096",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Obwalden",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2097",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Sankt Gallen",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2098",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Schaffhausen",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2099",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Schwyz",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2100",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Solothurn",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2101",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Thurgau",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2102",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Ticino",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2103",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Uri",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2104",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Valais",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2105",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Vaud",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2106",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Zug",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2107",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CH",
    "name": "Zurich",
    "timeZone": "Europe/Zurich"
  },
  {
    "id": "2108",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TW",
    "name": "Fu-chien",
    "timeZone": "Asia/Taipei"
  },
  {
    "id": "2109",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TW",
    "name": "Kao-hsiung",
    "timeZone": "Asia/Taipei"
  },
  {
    "id": "2110",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TW",
    "name": "Tai-pei",
    "timeZone": "Asia/Taipei"
  },
  {
    "id": "2111",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TW",
    "name": "Tai-wan",
    "timeZone": "Asia/Taipei"
  },
  {
    "id": "2112",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Ang Thong",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2113",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Buriram",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2114",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Chachoengsao",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2115",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Chai Nat",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2116",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Chaiyaphum",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2117",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Chanthaburi",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2118",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Chiang Mai",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2119",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Chiang Rai",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2120",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Chon Buri",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2121",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Chumphon",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2122",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Kalasin",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2123",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Kamphaeng Phet",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2124",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Kanchanaburi",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2125",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Khon Kaen",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2126",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Krabi",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2127",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Krung Thep",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2128",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Lampang",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2129",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Lamphun",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2130",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Loei",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2131",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Lop Buri",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2132",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Mae Hong Son",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2133",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Maha Sarakham",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2134",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Nakhon Nayok",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2135",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Nakhon Pathom",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2136",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Nakhon Phanom",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2137",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Nakhon Ratchasima",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2138",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Nakhon Sawan",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2139",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Nakhon Si Thammara",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2140",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Nan",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2141",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Narathiwat",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2142",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Nong Khai",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2143",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Nonthaburi",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2144",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Pathum Thani",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2145",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Pattani",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2146",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Phangnga",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2147",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Phatthalung",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2148",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Phayao",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2149",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Phetchabun",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2150",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Phetchaburi",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2151",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Phichit",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2152",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Phitsanulok",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2153",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Phra Nakhon Si Ayu",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2154",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Phrae",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2155",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Phuket",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2156",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Prachin Buri",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2157",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Prachuap Khiri Kha",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2158",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Ranong",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2159",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Ratchaburi",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2160",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Rayong",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2161",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Roi Et",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2162",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Sakon Nakhon",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2163",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Samut Prakan",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2164",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Samut Sakhon",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2165",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Samut Songkhram",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2166",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Saraburi",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2167",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Satun",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2168",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Sing Buri",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2169",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Sisaket",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2170",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Songkhla",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2171",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Sukhothai",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2172",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Suphan Buri",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2173",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Surat Thani",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2174",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Surin",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2175",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Tak",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2176",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Trang",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2177",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Trat",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2178",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Ubon Ratchathani",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2179",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Udon Thani",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2180",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Uthai Thani",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2181",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Uttaradit",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2182",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Yala",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2183",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TH",
    "name": "Yasothon",
    "timeZone": "Asia/Bangkok"
  },
  {
    "id": "2184",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TO",
    "name": "Ha apai",
    "timeZone": "Pacific/Tongatapu"
  },
  {
    "id": "2185",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TO",
    "name": "Tongatapu",
    "timeZone": "Pacific/Tongatapu"
  },
  {
    "id": "2186",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TO",
    "name": "Vava`u",
    "timeZone": "Pacific/Tongatapu"
  },
  {
    "id": "2187",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TT",
    "name": "Arima",
    "timeZone": "America/Port_of_Spain"
  },
  {
    "id": "2188",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TT",
    "name": "Caroni",
    "timeZone": "America/Port_of_Spain"
  },
  {
    "id": "2189",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TT",
    "name": "Mayaro",
    "timeZone": "America/Port_of_Spain"
  },
  {
    "id": "2190",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TT",
    "name": "Nariva",
    "timeZone": "America/Port_of_Spain"
  },
  {
    "id": "2191",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TT",
    "name": "Port-of-Spain",
    "timeZone": "America/Port_of_Spain"
  },
  {
    "id": "2192",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TT",
    "name": "Saint Andrew",
    "timeZone": "America/Port_of_Spain"
  },
  {
    "id": "2193",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TT",
    "name": "Saint David",
    "timeZone": "America/Port_of_Spain"
  },
  {
    "id": "2194",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TT",
    "name": "Saint George",
    "timeZone": "America/Port_of_Spain"
  },
  {
    "id": "2195",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TT",
    "name": "Saint Patrick",
    "timeZone": "America/Port_of_Spain"
  },
  {
    "id": "2196",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TT",
    "name": "San Fernando",
    "timeZone": "America/Port_of_Spain"
  },
  {
    "id": "2197",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TT",
    "name": "Tobago",
    "timeZone": "America/Port_of_Spain"
  },
  {
    "id": "2198",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TT",
    "name": "Victoria",
    "timeZone": "America/Port_of_Spain"
  },
  {
    "id": "2199",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Al Kaf",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2200",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Al Mahdiyah",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2201",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Al Munastir",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2202",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Al Qasrayn",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2203",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Al Qayrawan",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2204",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Aryanah",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2205",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Bajah",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2206",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Banzart",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2207",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Bin Arus",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2208",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Jundubah",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2209",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Madanin",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2210",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Nabul",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2211",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Qabis",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2212",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Qafsah",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2213",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Qibili",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2214",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Safaqis",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2215",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Sidi Bu Zayd",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2216",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Silyanah",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2217",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Susah",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2218",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Tatawin",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2219",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Tawzar",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2220",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Tunis",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2221",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TN",
    "name": "Zaghwan",
    "timeZone": "Africa/Tunis"
  },
  {
    "id": "2222",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Adana",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2223",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Adiyaman",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2224",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Afyon",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2225",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Agri",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2226",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Aksaray",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2227",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Amasya",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2228",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Ankara",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2229",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Antalya",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2230",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Artvin",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2231",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Aydin",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2232",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Balikesir",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2233",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Batman",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2234",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Bayburt",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2235",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Bilecik",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2236",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Bingol",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2237",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Bitlis",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2238",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Bolu",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2239",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Burdur",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2240",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Bursa",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2241",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Canakkale",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2242",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Cankiri",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2243",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Corum",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2244",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Denizli",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2245",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Diyarbakir",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2246",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Edirne",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2247",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Elazig",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2248",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Erzincan",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2249",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Erzurum",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2250",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Eskisehir",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2251",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Gaziantep",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2252",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Giresun",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2253",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Gumushane",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2254",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Hakkari",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2255",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Hatay",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2256",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Icel",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2257",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Isparta",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2258",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Istanbul",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2259",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Izmir",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2260",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Kahraman Maras",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2261",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Karaman",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2262",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Kars",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2263",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Kastamonu",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2264",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Kayseri",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2265",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Kirikkale",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2266",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Kirklareli",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2267",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Kirsehir",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2268",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Kocaeli",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2269",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Konya",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2270",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Kutahya",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2271",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Malatya",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2272",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Manisa",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2273",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Mardin",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2274",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Mugla",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2275",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Mus",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2276",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Nevsehir",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2277",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Nigde",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2278",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Ordu",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2279",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Rize",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2280",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Sakarya",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2281",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Samsun",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2282",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Siirt",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2283",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Sinop",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2284",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Sirnak",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2285",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Sivas",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2286",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Tekirdag",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2287",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Tokat",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2288",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Trabzon",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2289",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Tunceli",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2290",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Urfa",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2291",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Usak",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2292",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Van",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2293",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Yozgat",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2294",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "TR",
    "name": "Zonguldak",
    "timeZone": "Europe/Istanbul"
  },
  {
    "id": "2295",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UG",
    "name": "Busoga",
    "timeZone": "Africa/Kampala"
  },
  {
    "id": "2296",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UG",
    "name": "Central",
    "timeZone": "Africa/Kampala"
  },
  {
    "id": "2297",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UG",
    "name": "Eastern",
    "timeZone": "Africa/Kampala"
  },
  {
    "id": "2298",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UG",
    "name": "Karamoja",
    "timeZone": "Africa/Kampala"
  },
  {
    "id": "2299",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UG",
    "name": "Nile",
    "timeZone": "Africa/Kampala"
  },
  {
    "id": "2300",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UG",
    "name": "North Buganda",
    "timeZone": "Africa/Kampala"
  },
  {
    "id": "2301",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UG",
    "name": "Northern",
    "timeZone": "Africa/Kampala"
  },
  {
    "id": "2302",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UG",
    "name": "South Buganda",
    "timeZone": "Africa/Kampala"
  },
  {
    "id": "2303",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UG",
    "name": "Southern",
    "timeZone": "Africa/Kampala"
  },
  {
    "id": "2304",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UG",
    "name": "Western",
    "timeZone": "Africa/Kampala"
  },
  {
    "id": "2305",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Cherkas'ka Oblast'",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2306",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Chernihivs'ka Obla",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2307",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Chernivets'ka Obla",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2308",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Dnipropetrovs'ka O",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2309",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Donets'ka Oblast'",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2310",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Ivano-Frankivs'ka",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2311",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Kharkivs'ka Oblast",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2312",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Khersons'ka Oblast",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2313",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Khmel'nyts'ka Obla",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2314",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Kirovohrads'ka Obl",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2315",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Krym",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2316",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Kyyiv",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2317",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Kyyivs'ka Oblast'",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2318",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Luhans'ka Oblast'",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2319",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "L'vivs'ka Oblast'",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2320",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Mykolayivs'ka Obla",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2321",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Odes'ka Oblast'",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2322",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Poltavs'ka Oblast'",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2323",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Rivnens'ka Oblast'",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2324",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Sevastopol'",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2325",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Sums'ka Oblast'",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2326",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Ternopil's'ka Obla",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2327",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Vinnyts'ka Oblast'",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2328",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Volyns'ka Oblast'",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2329",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Zakarpats'ka Oblas",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2330",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Zaporiz'ka Oblast'",
    "timeZone": "Europe/Zaporozhye"
  },
  {
    "id": "2331",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UA",
    "name": "Zhytomyrs'ka Oblas",
    "timeZone": "Europe/Kiev"
  },
  {
    "id": "2332",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AE",
    "name": "Abu Zaby",
    "timeZone": "Asia/Dubai"
  },
  {
    "id": "2333",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AE",
    "name": "Ajman",
    "timeZone": "Asia/Dubai"
  },
  {
    "id": "2334",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AE",
    "name": "Al Fujayrah",
    "timeZone": "Asia/Dubai"
  },
  {
    "id": "2335",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AE",
    "name": "Ash Shariqah",
    "timeZone": "Asia/Dubai"
  },
  {
    "id": "2336",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AE",
    "name": "Dubayy",
    "timeZone": "Asia/Dubai"
  },
  {
    "id": "2337",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AE",
    "name": "Ra's al Khaymah",
    "timeZone": "Asia/Dubai"
  },
  {
    "id": "2338",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "AE",
    "name": "Umm al Qaywayn",
    "timeZone": "Asia/Dubai"
  },
  {
    "id": "2339",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Antrim",
    "timeZone": "Europe/London"
  },
  {
    "id": "2340",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Ards",
    "timeZone": "Europe/London"
  },
  {
    "id": "2341",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Armagh",
    "timeZone": "Europe/London"
  },
  {
    "id": "2342",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Avon",
    "timeZone": "Europe/London"
  },
  {
    "id": "2343",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Ballymena",
    "timeZone": "Europe/London"
  },
  {
    "id": "2344",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Ballymoney",
    "timeZone": "Europe/London"
  },
  {
    "id": "2345",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Banbridge",
    "timeZone": "Europe/London"
  },
  {
    "id": "2346",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Bedford",
    "timeZone": "Europe/London"
  },
  {
    "id": "2347",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Belfast",
    "timeZone": "Europe/London"
  },
  {
    "id": "2348",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Berkshire",
    "timeZone": "Europe/London"
  },
  {
    "id": "2349",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Borders",
    "timeZone": "Europe/London"
  },
  {
    "id": "2350",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Buckingham",
    "timeZone": "Europe/London"
  },
  {
    "id": "2351",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Cambridge",
    "timeZone": "Europe/London"
  },
  {
    "id": "2352",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Carrickfergus",
    "timeZone": "Europe/London"
  },
  {
    "id": "2353",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Castlereagh",
    "timeZone": "Europe/London"
  },
  {
    "id": "2354",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Central",
    "timeZone": "Europe/London"
  },
  {
    "id": "2355",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Cheshire",
    "timeZone": "Europe/London"
  },
  {
    "id": "2356",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Cleveland",
    "timeZone": "Europe/London"
  },
  {
    "id": "2357",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Clwyd",
    "timeZone": "Europe/London"
  },
  {
    "id": "2358",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Coleraine",
    "timeZone": "Europe/London"
  },
  {
    "id": "2359",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Cookstown",
    "timeZone": "Europe/London"
  },
  {
    "id": "2360",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Cornwall",
    "timeZone": "Europe/London"
  },
  {
    "id": "2361",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Craigavon",
    "timeZone": "Europe/London"
  },
  {
    "id": "2362",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Cumbria",
    "timeZone": "Europe/London"
  },
  {
    "id": "2363",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Derby",
    "timeZone": "Europe/London"
  },
  {
    "id": "2364",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Devon",
    "timeZone": "Europe/London"
  },
  {
    "id": "2365",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Dorset",
    "timeZone": "Europe/London"
  },
  {
    "id": "2366",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Down",
    "timeZone": "Europe/London"
  },
  {
    "id": "2367",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Dumfries and Gallo",
    "timeZone": "Europe/London"
  },
  {
    "id": "2368",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Dungannon",
    "timeZone": "Europe/London"
  },
  {
    "id": "2369",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Durham",
    "timeZone": "Europe/London"
  },
  {
    "id": "2370",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Dyfed",
    "timeZone": "Europe/London"
  },
  {
    "id": "2371",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "East Sussex"
  },
  {
    "id": "2372",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Essex",
    "timeZone": "Europe/London"
  },
  {
    "id": "2373",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Fermanagh",
    "timeZone": "Europe/London"
  },
  {
    "id": "2374",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Fife",
    "timeZone": "Europe/London"
  },
  {
    "id": "2375",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Gloucester",
    "timeZone": "Europe/London"
  },
  {
    "id": "2376",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Grampian",
    "timeZone": "Europe/London"
  },
  {
    "id": "2377",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Greater Europe/London",
    "timeZone": "Europe/London"
  },
  {
    "id": "2378",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Greater Manchester",
    "timeZone": "Europe/London"
  },
  {
    "id": "2379",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Gwent",
    "timeZone": "Europe/London"
  },
  {
    "id": "2380",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Gwynedd",
    "timeZone": "Europe/London"
  },
  {
    "id": "2381",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Hampshire",
    "timeZone": "Europe/London"
  },
  {
    "id": "2382",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Hereford and Worce",
    "timeZone": "Europe/London"
  },
  {
    "id": "2383",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Hertford",
    "timeZone": "Europe/London"
  },
  {
    "id": "2384",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Highland",
    "timeZone": "Europe/London"
  },
  {
    "id": "2385",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Humberside",
    "timeZone": "Europe/London"
  },
  {
    "id": "2386",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Isle of Wight",
    "timeZone": "Europe/London"
  },
  {
    "id": "2387",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Kent",
    "timeZone": "Europe/London"
  },
  {
    "id": "2388",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Lancashire",
    "timeZone": "Europe/London"
  },
  {
    "id": "2389",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Larne",
    "timeZone": "Europe/London"
  },
  {
    "id": "2390",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Leicester",
    "timeZone": "Europe/London"
  },
  {
    "id": "2391",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Limavady",
    "timeZone": "Europe/London"
  },
  {
    "id": "2392",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Lincoln",
    "timeZone": "Europe/London"
  },
  {
    "id": "2393",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Lisburn",
    "timeZone": "Europe/London"
  },
  {
    "id": "2394",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Europe/Londonderry",
    "timeZone": "Europe/London"
  },
  {
    "id": "2395",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Lothian",
    "timeZone": "Europe/London"
  },
  {
    "id": "2396",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Magherafelt",
    "timeZone": "Europe/London"
  },
  {
    "id": "2397",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Merseyside",
    "timeZone": "Europe/London"
  },
  {
    "id": "2398",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Mid Glamorgan",
    "timeZone": "Europe/London"
  },
  {
    "id": "2399",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Moyle",
    "timeZone": "Europe/London"
  },
  {
    "id": "2400",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Newry and Mourne",
    "timeZone": "Europe/London"
  },
  {
    "id": "2401",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Newtownabbey",
    "timeZone": "Europe/London"
  },
  {
    "id": "2402",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Norfolk",
    "timeZone": "Europe/London"
  },
  {
    "id": "2403",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "North Down",
    "timeZone": "Europe/London"
  },
  {
    "id": "2404",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "North Yorkshire",
    "timeZone": "Europe/London"
  },
  {
    "id": "2405",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Northampton",
    "timeZone": "Europe/London"
  },
  {
    "id": "2406",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Northumberland",
    "timeZone": "Europe/London"
  },
  {
    "id": "2407",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Nottingham",
    "timeZone": "Europe/London"
  },
  {
    "id": "2408",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Omagh",
    "timeZone": "Europe/London"
  },
  {
    "id": "2409",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Orkney",
    "timeZone": "Europe/London"
  },
  {
    "id": "2410",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Oxford",
    "timeZone": "Europe/London"
  },
  {
    "id": "2411",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Powys",
    "timeZone": "Europe/London"
  },
  {
    "id": "2412",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Shetland",
    "timeZone": "Europe/London"
  },
  {
    "id": "2413",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Shropshire",
    "timeZone": "Europe/London"
  },
  {
    "id": "2414",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Somerset",
    "timeZone": "Europe/London"
  },
  {
    "id": "2415",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "South Glamorgan",
    "timeZone": "Europe/London"
  },
  {
    "id": "2416",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "South Yorkshire",
    "timeZone": "Europe/London"
  },
  {
    "id": "2417",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Stafford",
    "timeZone": "Europe/London"
  },
  {
    "id": "2418",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Strabane",
    "timeZone": "Europe/London"
  },
  {
    "id": "2419",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Strathclyde",
    "timeZone": "Europe/London"
  },
  {
    "id": "2420",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Suffolk",
    "timeZone": "Europe/London"
  },
  {
    "id": "2421",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Surrey",
    "timeZone": "Europe/London"
  },
  {
    "id": "2422",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Tayside",
    "timeZone": "Europe/London"
  },
  {
    "id": "2423",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Tyne and Wear",
    "timeZone": "Europe/London"
  },
  {
    "id": "2424",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Warwick",
    "timeZone": "Europe/London"
  },
  {
    "id": "2425",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "West Glamorgan",
    "timeZone": "Europe/London"
  },
  {
    "id": "2426",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "West Midlands",
    "timeZone": "Europe/London"
  },
  {
    "id": "2427",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "West Sussex",
    "timeZone": "Europe/London"
  },
  {
    "id": "2428",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "West Yorkshire",
    "timeZone": "Europe/London"
  },
  {
    "id": "2429",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Western Isles",
    "timeZone": "Europe/London"
  },
  {
    "id": "2430",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Wiltshire",
    "timeZone": "Europe/London"
  },
  {
    "id": "2431",
    "stateCode": "AL",
    "capitalCityName": "Montgomery",
    "countryCode": "US",
    "name": "Alabama",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2432",
    "stateCode": "AK",
    "capitalCityName": "Juneau",
    "countryCode": "US",
    "name": "Alaska",
    "timeZone": "America/Juneau"
  },
  {
    "id": "2433",
    "stateCode": "AZ",
    "capitalCityName": "Phoenix",
    "countryCode": "US",
    "name": "Arizona",
    "timeZone": "America/Phoenix"
  },
  {
    "id": "2434",
    "stateCode": "AR",
    "capitalCityName": "Little rock",
    "countryCode": "US",
    "name": "Arkansas",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2435",
    "stateCode": "CA",
    "capitalCityName": "Sacramento",
    "countryCode": "US",
    "name": "California",
    "timeZone": "America/Los_Angeles"
  },
  {
    "id": "2436",
    "stateCode": "CO",
    "capitalCityName": "Denver",
    "countryCode": "US",
    "name": "Colorado",
    "timeZone": "America/Denver"
  },
  {
    "id": "2437",
    "stateCode": "CT",
    "capitalCityName": "Hartford",
    "countryCode": "US",
    "name": "Connecticut",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2438",
    "stateCode": "DE",
    "capitalCityName": "Dover",
    "countryCode": "US",
    "name": "Delaware",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2439",
    "stateCode": "DC",
    "capitalCityName": "Washington",
    "countryCode": "US",
    "name": "District of Columb",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2440",
    "stateCode": "FL",
    "capitalCityName": "Tallahassee",
    "countryCode": "US",
    "name": "Florida",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2441",
    "stateCode": "GA",
    "capitalCityName": "Atlanta",
    "countryCode": "US",
    "name": "Georgia",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2442",
    "stateCode": "HI",
    "capitalCityName": "Honolulu",
    "countryCode": "US",
    "name": "Hawaii",
    "timeZone": "Pacific/Honolulu"
  },
  {
    "id": "2443",
    "stateCode": "ID",
    "capitalCityName": "Boise",
    "countryCode": "US",
    "name": "Idaho",
    "timeZone": "America/Boise"
  },
  {
    "id": "2444",
    "stateCode": "IL",
    "capitalCityName": "Springfield",
    "countryCode": "US",
    "name": "Illinois",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2445",
    "stateCode": "IN",
    "capitalCityName": "Indianapolis",
    "countryCode": "US",
    "name": "Indiana",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2446",
    "stateCode": "IA",
    "capitalCityName": "Des Moines",
    "countryCode": "US",
    "name": "Iowa",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2447",
    "stateCode": "KS",
    "capitalCityName": "Topeka",
    "countryCode": "US",
    "name": "Kansas",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2448",
    "stateCode": "KY",
    "capitalCityName": "Frankfort",
    "countryCode": "US",
    "name": "Kentucky",
    "timeZone": "America/Kentucky/Louisville"
  },
  {
    "id": "2449",
    "stateCode": "LA",
    "capitalCityName": "Baton Rouge",
    "countryCode": "US",
    "name": "Louisiana",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2450",
    "stateCode": "ME",
    "capitalCityName": "Augusta",
    "countryCode": "US",
    "name": "Maine",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2451",
    "stateCode": "MD",
    "capitalCityName": "Annapolis",
    "countryCode": "US",
    "name": "Maryland",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2452",
    "stateCode": "MA",
    "capitalCityName": "Boston",
    "countryCode": "US",
    "name": "Massachusetts",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2453",
    "stateCode": "MI",
    "capitalCityName": "Lansing",
    "countryCode": "US",
    "name": "Michigan",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2454",
    "stateCode": "MN",
    "capitalCityName": "St.Paul",
    "countryCode": "US",
    "name": "Minnesota",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2455",
    "stateCode": "MS",
    "capitalCityName": "Jackson",
    "countryCode": "US",
    "name": "Mississippi",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2456",
    "stateCode": "MO",
    "capitalCityName": "Jefferson City",
    "countryCode": "US",
    "name": "Missouri",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2457",
    "stateCode": "MT",
    "capitalCityName": "Helena",
    "countryCode": "US",
    "name": "Montana",
    "timeZone": "America/Boise"
  },
  {
    "id": "2458",
    "stateCode": "NE",
    "capitalCityName": "Lincoln",
    "countryCode": "US",
    "name": "Nebraska",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2459",
    "stateCode": "NH",
    "capitalCityName": "Concord",
    "countryCode": "US",
    "name": "New Hampshire",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2460",
    "stateCode": "NJ",
    "capitalCityName": "Trenton",
    "countryCode": "US",
    "name": "New Jersey",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2461",
    "stateCode": "NM",
    "capitalCityName": "Santa Fe",
    "countryCode": "US",
    "name": "New Mexico",
    "timeZone": "America/Boise"
  },
  {
    "id": "2462",
    "stateCode": "NY",
    "capitalCityName": "Albany",
    "countryCode": "US",
    "name": "New York",
    "timeZone": "America/New_York"
  },
  {
    "id": "2463",
    "stateCode": "NV",
    "capitalCityName": "Carson City",
    "countryCode": "US",
    "name": "Nevada",
    "timeZone": "America/Anchorage"
  },
  {
    "id": "2464",
    "stateCode": "NC",
    "capitalCityName": "Raleigh",
    "countryCode": "US",
    "name": "North Carolina",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2465",
    "stateCode": "ND",
    "capitalCityName": "Bismarck",
    "countryCode": "US",
    "name": "North Dakota",
    "timeZone": "America/North_Dakota/New_Salem"
  },
  {
    "id": "2466",
    "stateCode": "OH",
    "capitalCityName": "Columbus",
    "countryCode": "US",
    "name": "Ohio",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2467",
    "stateCode": "OK",
    "capitalCityName": "Oklahoma City",
    "countryCode": "US",
    "name": "Oklahoma",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2468",
    "stateCode": "OR",
    "capitalCityName": "Salem",
    "countryCode": "US",
    "name": "Oregon",
    "timeZone": "America/Anchorage"
  },
  {
    "id": "2469",
    "stateCode": "PA",
    "capitalCityName": "Harrisburg",
    "countryCode": "US",
    "name": "Pennsylvania",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2470",
    "stateCode": "RL",
    "capitalCityName": "Providence",
    "countryCode": "US",
    "name": "Rhode Island",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2471",
    "stateCode": "SC",
    "capitalCityName": "Columbia",
    "countryCode": "US",
    "name": "South Carolina",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2472",
    "stateCode": "SD",
    "capitalCityName": "Pierre",
    "countryCode": "US",
    "name": "South Dakota",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2473",
    "stateCode": "TN",
    "capitalCityName": "Nashville",
    "countryCode": "US",
    "name": "Tennessee",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2474",
    "stateCode": "TX",
    "capitalCityName": "Austin",
    "countryCode": "US",
    "name": "Texas",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2475",
    "stateCode": "UT",
    "capitalCityName": "Salt Lake City",
    "countryCode": "US",
    "name": "Utah",
    "timeZone": "America/Boise"
  },
  {
    "id": "2476",
    "stateCode": "WA",
    "capitalCityName": "Olympia",
    "countryCode": "US",
    "name": "Washington",
    "timeZone": "America/Anchorage"
  },
  {
    "id": "2477",
    "stateCode": "VT",
    "capitalCityName": "Montpelier",
    "countryCode": "US",
    "name": "Vermont",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2478",
    "stateCode": "WV",
    "capitalCityName": "Charleston",
    "countryCode": "US",
    "name": "West Virginia",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2479",
    "stateCode": "VA",
    "capitalCityName": "Richmond",
    "countryCode": "US",
    "name": "Virginia",
    "timeZone": "America/Indiana/Indianapolis"
  },
  {
    "id": "2480",
    "stateCode": "WI",
    "capitalCityName": "Madison",
    "countryCode": "US",
    "name": "Wisconsin",
    "timeZone": "America/Chicago"
  },
  {
    "id": "2481",
    "stateCode": "WY",
    "capitalCityName": "Cheyenne",
    "countryCode": "US",
    "name": "Wyoming",
    "timeZone": "America/Boise"
  },
  {
    "id": "2482",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Artigas",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2483",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Canelones",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2484",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Cerro Largo",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2485",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Colonia",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2486",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Durazno",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2487",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Flores",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2488",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Florida",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2489",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Lavalleja",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2490",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Maldonado",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2491",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Montevideo",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2492",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Paysandu",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2493",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Rio Negro",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2494",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Rivera",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2495",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Rocha",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2496",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Salto",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2497",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "San Jose",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2498",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Soriano",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2499",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Tacuarembo",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2500",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "UY",
    "name": "Treinta y Tres",
    "timeZone": "America/Montevideo"
  },
  {
    "id": "2501",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VU",
    "name": "Ambrym",
    "timeZone": "Pacific/Efate"
  },
  {
    "id": "2502",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VU",
    "name": "Aoba/Maewo",
    "timeZone": "Pacific/Efate"
  },
  {
    "id": "2503",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VU",
    "name": "Banks/Torres",
    "timeZone": "Pacific/Efate"
  },
  {
    "id": "2504",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VU",
    "name": "Efate",
    "timeZone": "Pacific/Efate"
  },
  {
    "id": "2505",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VU",
    "name": "Epi",
    "timeZone": "Pacific/Efate"
  },
  {
    "id": "2506",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VU",
    "name": "Malakula",
    "timeZone": "Pacific/Efate"
  },
  {
    "id": "2507",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VU",
    "name": "Paama",
    "timeZone": "Pacific/Efate"
  },
  {
    "id": "2508",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VU",
    "name": "Pentecote",
    "timeZone": "Pacific/Efate"
  },
  {
    "id": "2509",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VU",
    "name": "Santo/Malo",
    "timeZone": "Pacific/Efate"
  },
  {
    "id": "2510",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VU",
    "name": "Shepherd",
    "timeZone": "Pacific/Efate"
  },
  {
    "id": "2511",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VU",
    "name": "Tafea",
    "timeZone": "Pacific/Efate"
  },
  {
    "id": "2512",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Amazonas",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2513",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Anzoategui",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2514",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Apure",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2515",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Aragua",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2516",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Barinas",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2517",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Bolivar",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2518",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Carabobo",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2519",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Cojedes",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2520",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Delta Amacuro",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2521",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Dependencias Feder",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2522",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Distrito Federal",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2523",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Falcon",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2524",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Guarico",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2525",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Lara",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2526",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Merida",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2527",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Miranda",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2528",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Monagas",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2529",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Nueva Esparta",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2530",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Portuguesa",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2531",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Sucre",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2532",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Tachira",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2533",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Trujillo",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2534",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Yaracuy",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2535",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VE",
    "name": "Zulia",
    "timeZone": "America/Caracas"
  },
  {
    "id": "2536",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "An Giang",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2537",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Ba Ria-Vung Tau",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2538",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Bac Thai",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2539",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Ben Tre",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2540",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Binh Dinh",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2541",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Binh Thuan",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2542",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Can Tho",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2543",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Cao Bang",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2544",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Dac Lac",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2545",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Dong Nai",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2546",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Dong Thap",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2547",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Gia Lai",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2548",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Ha Bac",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2549",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Ha Giang",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2550",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Ha Noi",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2551",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Ha Tay",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2552",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Ha Tinh",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2553",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Hai Hung",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2554",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Hai Phong",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2555",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Ho Chi Minh",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2556",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Hoa Binh",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2557",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Khanh Hoa",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2558",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Kien Giang",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2559",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Kon Tum",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2560",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Lai Chau",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2561",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Lam Dong",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2562",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Lang Son",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2563",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Lao Cai",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2564",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Long An",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2565",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Minh Hai",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2566",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Nam Ha",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2567",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Nghe An",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2568",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Ninh Binh",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2569",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Ninh Thuan",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2570",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Phu Yen",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2571",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Quang Binh",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2572",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Quang Nam-Da Nang",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2573",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Quang Ngai",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2574",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Quang Ninh",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2575",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Quang Tri",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2576",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Soc Trang",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2577",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Son La",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2578",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Song Be",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2579",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Tay Ninh",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2580",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Thai Binh",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2581",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Thanh Hoa",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2582",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Thua Thien",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2583",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Tien Giang",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2584",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Tra Vinh",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2585",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Tuyen Quang",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2586",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Vinh Long",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2587",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Vinh Phu",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2588",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "VN",
    "name": "Yen Bai",
    "timeZone": "Asia/Ho_Chi_Minh"
  },
  {
    "id": "2589",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Abyan",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2590",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Adan",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2591",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Al Bayda",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2592",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Al Hudaydah",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2593",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Al Jawf",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2594",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Al Mahrah",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2595",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Al Mahwit",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2596",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Dhamar",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2597",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Hadramawt",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2598",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Hajjah",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2599",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Ibb",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2600",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Lahij",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2601",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Ma'rib",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2602",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Sa dah",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2603",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "San a'",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2604",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Shabwah",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2605",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "YE",
    "name": "Ta izz",
    "timeZone": "Asia/Aden"
  },
  {
    "id": "2606",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZM",
    "name": "Central",
    "timeZone": "Africa/Lusaka"
  },
  {
    "id": "2607",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZM",
    "name": "Copperbelt",
    "timeZone": "Africa/Lusaka"
  },
  {
    "id": "2608",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZM",
    "name": "Eastern",
    "timeZone": "Africa/Lusaka"
  },
  {
    "id": "2609",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZM",
    "name": "Luapula",
    "timeZone": "Africa/Lusaka"
  },
  {
    "id": "2610",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZM",
    "name": "Lusaka",
    "timeZone": "Africa/Lusaka"
  },
  {
    "id": "2611",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZM",
    "name": "Northern",
    "timeZone": "Africa/Lusaka"
  },
  {
    "id": "2612",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZM",
    "name": "North-Western",
    "timeZone": "Africa/Lusaka"
  },
  {
    "id": "2613",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZM",
    "name": "Southern",
    "timeZone": "Africa/Lusaka"
  },
  {
    "id": "2614",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZM",
    "name": "Western",
    "timeZone": "Africa/Lusaka"
  },
  {
    "id": "2615",
    "stateCode": null,
    "capitalCityName": "SunshineCoast",
    "countryCode": "AU",
    "name": "Sunshine Coast",
    "timeZone": "Australia/Brisbane"
  },
  {
    "id": "2616",
    "stateCode": null,
    "capitalCityName": "GoldCoast",
    "countryCode": "AU",
    "name": "Gold Coast",
    "timeZone": "Australia/Brisbane"
  },
  {
    "id": "2617",
    "stateCode": null,
    "capitalCityName": "ByronLismore",
    "countryCode": "AU",
    "name": "Byron/Lismore",
    "timeZone": "Australia/Broken_Hill"
  },
  {
    "id": "2618",
    "stateCode": null,
    "capitalCityName": "CentralCoast",
    "countryCode": "AU",
    "name": "Central Coast",
    "timeZone": "Australia/Brisbane"
  },
  {
    "id": "2619",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZA",
    "name": "The Eastern Cape",
    "timeZone": "Africa/Johannesburg"
  },
  {
    "id": "2620",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZA",
    "name": "Western Cape",
    "timeZone": "Africa/Johannesburg"
  },
  {
    "id": "2621",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZA",
    "name": "Limpopo",
    "timeZone": "Africa/Johannesburg"
  },
  {
    "id": "2622",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZA",
    "name": "North West",
    "timeZone": "Africa/Johannesburg"
  },
  {
    "id": "2623",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "ZA",
    "name": "Mpumalanga",
    "timeZone": "Africa/Johannesburg"
  },
  {
    "id": "2730",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CS",
    "name": "Vojvodina",
    "timeZone": "Europe/Belgrade"
  },
  {
    "id": "2731",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CS",
    "name": "Belgrade",
    "timeZone": "Europe/Belgrade"
  },
  {
    "id": "2732",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CS",
    "name": "Šumadija and Western Serbia",
    "timeZone": "Europe/Belgrade"
  },
  {
    "id": "2733",
    "stateCode": null,
    "capitalCityName": null,
    "countryCode": "CS",
    "name": "Southern and Eastern Serbia",
    "timeZone": "Europe/Belgrade"
  },
  {
    "id": "2734",
    "stateCode": null,
    "capitalCityName": null, 
    "countryCode": "CS",
    "name": "Kosovo and Metohija",
    "timeZone": "Europe/Belgrade" 
  },
  {
    "id": "2735",
    "stateCode": "SK",
    "capitalCityName": null, 
    "countryCode": "KN",
    "name": "Saint Kitts",
    "timeZone": "America/St_Kitts" 
  },
  {
    "id": "2736",
    "stateCode": "NV",
    "capitalCityName": null, 
    "countryCode": "KN",
    "name": "Nevis",
    "timeZone": "America/St_Kitts" 
  },
  {
    "id": "2737",
    "stateCode": "SC",
    "capitalCityName": null,
    "countryCode": "UK",
    "name": "Scotland",
    "timeZone": "Europe/London"
  }
  // {
  //   "id": "2624",
  //   "stateCode": null,
  //   "capitalCityName": null,
  //   "countryCode": "ZA",
  //   "name": "Mpumalanga",
  //   "timeZone": "Africa/Johannesburg"
  // },
  // {
  //   "id": "2625",
  //   "stateCode": null,
  //   "capitalCityName": null,
  //   "countryCode": "ZA",
  //   "name": "The Northern Cape",
  //   "timeZone": "Africa/Johannesburg"
  // },
  // {
  //   "id": "2626",
  //   "stateCode": null,
  //   "capitalCityName": null,
  //   "countryCode": "ZA",
  //   "name": "North West",
  //   "timeZone": "Africa/Johannesburg"
  // },
  // {
  //   "id": "2627",
  //   "stateCode": null,
  //   "capitalCityName": null,
  //   "countryCode": "ZA",
  //   "name": "The Western Cape",
  //   "timeZone": "Africa/Johannesburg"
  // },
];

export default States;


// WEBPACK FOOTER //
// ./src/data/states.js